import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid2,
  MenuItem,
  Select,
  Stack,
  TableCell,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { fixedJob, getJdNotes } from "../../../../api/Api";
// import ShareQuickMatch from "../../../matches/access-team-fit/access-team-fit-create/components/ShareQuickMatch";
// import PopupTickIco from "../../../../assets/icons/PopupTickIco";
import PopupTickIco from "../../../../assets/icons/PopupTickIco";
import CommonButton from "../../../../component/Button";
import SnackBar from "../../../../component/SnackBar";
import { JobJobEdit, JobJobReScore } from "../../../../redux/action/Job";
import { GET } from "../../../../redux/axios/Axios";
import {
  CommonGrid2,
  CustomAccordion,
  StyledFlexColumnView,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";
import CreateNote from "./CreateNote";
// import NewDeleteNote from "./NewDeleteNote";
// import ShareQuickMatch from "../../../quick-match/components/ShareQuickMatch";
// import { Industry, SowData } from "../../../../utils/helo-jem";
import AddSeededDialog from "../../../jobs/create-job/components/AddSeededDialog";
// import CreateNote from "../../../jobs/create-job/components/CreateNote";
import EditIndex from "./EditIndex";
import NewDeleteNote from "./NewDeleteNote";
import Notes from "./Notes";
// import RelevancyTable from "../../../jobs/create-job/components/RelavancyIndex";
import DialogCandidateHub from "../../../jobs/jobs-candidate/components/DialogCandidateHub";
import ShareQuickMatch from "../../../matches/quick-match/components/ShareQuickMatch";
// import ActivatePopup from "./ActivatePopup";
import { ExpandMore, MoreVertOutlined } from "@mui/icons-material";
import AssembleTeamIco from "../../../../assets/icons/AssembleTeamIco.js";
import BoxEditIco from "../../../../assets/icons/BoxEditIco.js";
import DeleteIco from "../../../../assets/icons/DeleteIco.js";
import DnaIco from "../../../../assets/icons/DnaIco";
import DoucmentIco from "../../../../assets/icons/DoucmentIco.js";
import ProjectTimelineIco from "../../../../assets/icons/ProjectTimelineIco.js";
import PuzzleIco from "../../../../assets/icons/PuzzleIco";
import QuestionnaireIco from "../../../../assets/icons/QuestionnaireIco.js";
import SaveIco from "../../../../assets/icons/SaveIco";
import SocksIco from "../../../../assets/icons/SocksIco";
import SquareBoxPendingIco from "../../../../assets/icons/SquareBoxPendingIco.js";
import SquareBoxTickIco from "../../../../assets/icons/SquareBoxTickIco.js";
import TeamCompositionIco from "../../../../assets/icons/TeamCompositionIco.js";
import CustomMenuItem from "../../../../component/Menu/index.js";
import CommonCard from "../../../jobs/common-card.js";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent.js";
import AddIgniteSkill from "../../sow-enrichment-copy/components/AddIgniteSkill";
// import IgniteStrategy from "../../sow-enrichment/components/IgniteStrategy";
// import IgniteSummary from "../../sow-enrichment/components/IgniteSummary";
import SkillDeleteDialog from "../../../common-components/DeleteDialog.js";
import Checklist from "./Checklist.js";
import IgnitePopup from "./IgnitePopup";
import IgniteStrategy from "./IgniteStrategy.js";
import IgniteSummary from "./IgniteSummary.js";
import SubmitBidPopup from "./SubmitBidPopup";

const handleDynmaicList = (data) => {
  return data?.flatMap((item) =>
    item?.content?.map((contentItem) => ({
      name: item?.name,
      content: contentItem,
    }))
  );
};

const Industry = [
  {
    id: "b28d2172-4c1e-4d12-b048-1561a7541d02",
    name: "Government",
    type: "default",
  },
  {
    id: "b28d2172-4c1e-4d12-b048-1561a7041d02",
    name: "eCommerce",
    type: "default",
  },
  {
    id: "b28d2172-4c1e-4d12-b048-1561a7541d05",
    name: "Agriculture",
    type: "default",
  },
  {
    id: "0d9d6afd-c39b-45b7-a977-91624f697589",
    name: "Automotive",
    type: "default",
  },
  {
    id: "3d7ddfa8-13d5-4ffe-aeae-482d418f7731",
    name: "Banking & Finance",
    type: "default",
  },
  {
    id: "0bd67352-51cc-4935-b59a-b30b10b38959",
    name: "Biotechnology",
    type: "default",
  },
  {
    id: "2334f05f-68b2-435e-86f8-69d151dc99c1",
    name: "Construction",
    type: "default",
  },
  {
    id: "057da54d-3ace-43e0-a0a3-abad5e937bc8",
    name: "Consumer Goods",
    type: "default",
  },
  {
    id: "0297dd63-6057-4d1d-9aa8-ec0cda29467f",
    name: "Education",
    type: "default",
  },
  {
    id: "d93bb4fd-c67a-483d-938f-2000ea671647",
    name: "Energy & Utilities",
    type: "default",
  },
  {
    id: "8c028b79-89dd-4e4c-978b-5549e3158842",
    name: "Engineering",
    type: "default",
  },
  {
    id: "7eefdc58-52dd-422e-9a8a-833c684b0020",
    name: "Entertainment",
    type: "default",
  },
  {
    id: "aefcd477-4d57-4447-9404-d00aae567a5c",
    name: "Environmental Services",
    type: "default",
  },
  {
    id: "ba28738a-b20d-40b9-aaaf-77f9d363dbf7",
    name: "Fashion",
    type: "default",
  },
  {
    id: "b7f07447-6ed6-4c6a-ad85-6c894b123494",
    name: "Healthcare",
    type: "default",
  },
  {
    id: "d71bcd23-c476-4b5a-b748-11d7bb672e17",
    name: "Hospitality & Tourism",
    type: "default",
  },
  {
    id: "37592736-e512-41be-bd39-248da038633d",
    name: "Human Resources",
    type: "default",
  },
  {
    id: "5e5534f7-fd20-44f5-873e-32fcb547e003",
    name: "Information Technology",
    type: "default",
  },
  {
    id: "01148c34-22ef-4ea1-9fe7-b650b3cb23b8",
    name: "Insurance",
    type: "default",
  },
  {
    id: "0cb5a7ff-eb35-4bfd-be83-62dc3316ad95",
    name: "Legal Services",
    type: "default",
  },
  {
    id: "b3a041fd-e774-4534-990c-d810ba786e50",
    name: "Logistics & Supply Chain",
    type: "default",
  },
  {
    id: "3ec44c76-41f7-485f-866e-1e8cab2afcdc",
    name: "Manufacturing",
    type: "default",
  },
  {
    id: "dc808d74-aa6b-42cf-a568-d57c2547190a",
    name: "Marketing & Advertising",
    type: "default",
  },
  {
    id: "6ad38108-8b97-41d6-a46a-cc92dedabc91",
    name: "Media & Broadcasting",
    type: "default",
  },
  {
    id: "88304be5-24bf-4443-a6ae-ccb645d1f225",
    name: "Nonprofit",
    type: "default",
  },
  {
    id: "0d2db2a5-4e08-4f6e-9ce3-ff76ea0520d6",
    name: "Pharmaceuticals",
    type: "default",
  },
  {
    id: "101c56a1-0582-44cd-a677-4a2e0affbfbc",
    name: "Real Estate",
    type: "default",
  },
  {
    id: "2e6810df-4324-4431-b661-342724ef2368",
    name: "Retail",
    type: "default",
  },
  {
    id: "366f2a0a-d7d0-4ecb-8ba6-9fb20dd87024",
    name: "Science & Research",
    type: "default",
  },
  {
    id: "bfe272df-db45-4f99-a573-da3db3297871",
    name: "Telecommunications",
    type: "default",
  },
  {
    id: "72f1d075-795a-4690-8e45-4d4ca3873562",
    name: "Transportation",
    type: "default",
  },
  {
    id: "c00506ce-c595-49c2-acbc-c1f74b902e7f",
    name: "Waste Management",
    type: "default",
  },
];

const SowData = {
  skillData: {
    high_priority: [
      {
        id: "6ee11337-2124-44a7-844b-b30107dd810d",
        skill: "Project Managment",
        expertise_level: "Hands-on",
        criticality_score: "10",
        experience_in_yrs: "10",
        category: "required",
        about_the_skill:
          "Python is crucial for data manipulation, machine learning, and statistical analysis, which are core functions of a data scientist.",
        relevancy_score: "95",
        bucket: "Core Skills",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "recommendedData",
      },
      {
        id: "bb499e7e-2208-4ab9-a285-b2b0fa7771ba",
        skill: "SF Proj.",
        expertise_level: "USP",
        criticality_score: "10",
        experience_in_yrs: "7",
        category: "required",
        about_the_skill:
          "Machine learning techniques are essential for creating models that predict educational outcomes and improve learning tools.",
        relevancy_score: "98",
        bucket: "Core Skills",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "recommendedData",
      },
      {
        id: "47a5950c-6230-41a9-a6c2-d0131f0b5dd1",
        skill: "Public Sector Experience",
        expertise_level: "Hands-on",
        criticality_score: "9",
        experience_in_yrs: "10",
        category: "required",
        about_the_skill:
          "SQL is vital for managing and querying large datasets, which is a daily task in data science roles.",
        relevancy_score: "90",
        bucket: "Core Skills",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "coreData",
      },
    ],
    low_priority: [
      {
        id: "b125cdf4-7b06-4324-a77f-3652c1a98f18",
        skill: "Team Leadership",
        expertise_level: "Familiar",
        criticality_score: "8",
        experience_in_yrs: "10",
        category: "preferred",
        about_the_skill:
          "R is used for statistical analysis and visualization, enhancing report generation and data interpretation.",
        relevancy_score: "80",
        bucket: "Complementary Skills",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "complementaryData",
      },
      {
        id: "7eafe404-aa75-4fd8-9ea4-726b839812d1",
        skill: "Stakeholder Mgmt.",
        expertise_level: "Familiar",
        criticality_score: "7",
        experience_in_yrs: "7",
        category: "preferred",
        about_the_skill:
          "Data visualization skills are important to present data insights effectively to stakeholders.",
        relevancy_score: "75",
        bucket: "Complementary Skills",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "complementaryData",
      },
      {
        id: "01bd59ae-db96-44e6-a172-327f7ee496ba",
        skill: "Visionary Thinking",
        expertise_level: "Familiar",
        criticality_score: "7",
        experience_in_yrs: "5",
        category: "preferred",
        about_the_skill:
          "Adapting to new tools and methodologies is crucial in the rapidly evolving field of data science.",
        relevancy_score: "75",
        bucket: "Complementary Skills",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "complementaryData",
      },
      {
        id: "3386fdb7-60ec-4ab9-a9ef-6f4a054ee479",
        skill: "Problem Solving",
        expertise_level: "Proven",
        criticality_score: "8",
        experience_in_yrs: "5",
        category: "preferred",
        about_the_skill:
          "Critical thinking helps in assessing the accuracy of data analysis results and making informed decisions.",
        relevancy_score: "78",
        bucket: "Complementary Skills",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "complementaryData",
      },
      {
        id: "3386fdb7-60ec-4ab9-a9ef-6f4a054ee479",
        skill: "Change Mgmt.",
        expertise_level: "Proven",
        criticality_score: "8",
        experience_in_yrs: "7",
        category: "preferred",
        about_the_skill:
          "Critical thinking helps in assessing the accuracy of data analysis results and making informed decisions.",
        relevancy_score: "78",
        bucket: "Complementary Skills",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "complementaryData",
      },
    ],
    recommended: [
      {
        skill: "Big Data Technologies (Hadoop, Spark)",
        expertise_level: "Familiar",
        criticality_score: "6",
        experience_in_yrs: "2",
        type: "recommendedData",
        bucket: "Core recommended",
      },
      {
        skill: "In-Store Retail Ops",
        expertise_level: "USP",
        criticality_score: "6",
        experience_in_yrs: "2",
        type: "recommendedData",
        bucket: "Core recommended",
      },
      {
        skill: "Marketing Skills",
        expertise_level: "Familiar",
        criticality_score: "6",
        experience_in_yrs: "2",
        type: "recommendedData",
        bucket: "Core recommended",
      },
    ],
    medium_priority: [
      {
        id: "09e68b03-b525-4c55-9a4a-d836d8657123",
        skill: "High Traffic",
        expertise_level: "Preferred",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Familiarity with Big Data technologies can improve the ability to handle extensive educational datasets.",
        relevancy_score: "60",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
      {
        id: "485dc648-67cd-4840-814f-9a328bcc4b90",
        skill: "Consumer Facing",
        expertise_level: "Desired",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Deep learning can provide advanced predictive capabilities and automate analysis processes.",
        relevancy_score: "65",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
      {
        id: "f46da86b-0840-4c8b-a894-7bb11c1d3a8f",
        skill: "> 1B PnL",
        expertise_level: "Desired",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Collaborating with different departments helps in aligning data strategies with organizational goals.",
        relevancy_score: "65",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
    ],
    salesforce_architect: [
      {
        id: "09e68b03-b525-4c55-9a4a-d836d8657123",
        skill: "Salesforce CRM",
        expertise_level: "Preferred",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Familiarity with Big Data technologies can improve the ability to handle extensive educational datasets.",
        relevancy_score: "60",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
      {
        id: "485dc648-67cd-4840-814f-9a328bcc4b90",
        skill: "Salesforce Solution Design & Architecture",
        expertise_level: "Desired",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Deep learning can provide advanced predictive capabilities and automate analysis processes.",
        relevancy_score: "65",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
      {
        id: "f46da86b-0840-4c8b-a894-7bb11c1d3a8f",
        skill: "Workflow Automation",
        expertise_level: "Desired",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Collaborating with different departments helps in aligning data strategies with organizational goals.",
        relevancy_score: "65",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
    ],
    salesforce_quality_assurance_analyst: [
      {
        id: "09e68b03-b525-4c55-9a4a-d836d8657123",
        skill: "Salesforce Testing (Manual & Automated)",
        expertise_level: "Preferred",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Familiarity with Big Data technologies can improve the ability to handle extensive educational datasets.",
        relevancy_score: "60",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
      {
        id: "485dc648-67cd-4840-814f-9a328bcc4b90",
        skill: "Apex Test Classes",
        expertise_level: "Desired",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Deep learning can provide advanced predictive capabilities and automate analysis processes.",
        relevancy_score: "65",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
      {
        id: "f46da86b-0840-4c8b-a894-7bb11c1d3a8f",
        skill: "Functional & Regression Testing",
        expertise_level: "Desired",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Collaborating with different departments helps in aligning data strategies with organizational goals.",
        relevancy_score: "65",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
    ],
    devOps_personnel: [
      {
        id: "09e68b03-b525-4c55-9a4a-d836d8657123",
        skill: "CI/CD Pipelines",
        expertise_level: "Preferred",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Familiarity with Big Data technologies can improve the ability to handle extensive educational datasets.",
        relevancy_score: "60",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
      {
        id: "485dc648-67cd-4840-814f-9a328bcc4b90",
        skill: "Cloud Platforms",
        expertise_level: "Desired",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Deep learning can provide advanced predictive capabilities and automate analysis processes.",
        relevancy_score: "65",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
      {
        id: "f46da86b-0840-4c8b-a894-7bb11c1d3a8f",
        skill: "Salesforce DevOps (SFDX, Copado, Gearset)",
        expertise_level: "Desired",
        criticality_score: "6",
        experience_in_yrs: "2",
        category: "nice to have",
        about_the_skill:
          "Collaborating with different departments helps in aligning data strategies with organizational goals.",
        relevancy_score: "65",
        bucket: "Additional Qualities",
        job_info: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
        type: "mediumData",
      },
    ],
  },
  id: "6d8e808a-deb1-4320-8821-fa1e28ac0764",
  job_title: "Project Atlantis",
  company_name: "State of Minnesota",
  industry: "Entertainment",
  duration: "24 Months",
  available_industry: [
    {
      id: "7412c349-eb05-4033-bd8b-61a812d74d53",
      name: "E-commerce",
      type: "default",
    },
    {
      id: "28e306a8-b400-4da2-9711-0ff4bdedcb85",
      name: "Agriculture",
      type: "default",
    },
    {
      id: "253a979f-7e4b-4964-88e8-83505e28d95e",
      name: "Automotive",
      type: "default",
    },
    {
      id: "cc8f38ce-e2ce-4ee5-b4a2-44d0d684ebe8",
      name: "Banking & Finance",
      type: "default",
    },
    {
      id: "7233a661-81c7-45e8-8eb6-f629ec34b184",
      name: "Biotechnology",
      type: "default",
    },
    {
      id: "434450af-e9c1-4d59-a982-e65321f82d88",
      name: "Construction",
      type: "default",
    },
    {
      id: "eb467dd3-5d2d-448e-ad7b-4398e39725ab",
      name: "Consumer Goods",
      type: "default",
    },
    {
      id: "e662d48e-5f01-4e6b-b107-a2b75461042b",
      name: "Education",
      type: "default",
    },
    {
      id: "3a21bbd0-4594-45f1-b136-5be271554ca2",
      name: "Energy & Utilities",
      type: "default",
    },
    {
      id: "bb8cdf9d-5cfd-4bb9-bd09-7fa074748272",
      name: "Engineering",
      type: "default",
    },
    {
      id: "b8595976-98bf-41ca-913b-6555a160348d",
      name: "Entertainment",
      type: "default",
    },
    {
      id: "bc582f6b-6bfb-4e71-b398-5046fd41e04c",
      name: "Environmental Services",
      type: "default",
    },
    {
      id: "b0bdd536-699d-4b72-b005-e87401d63dc7",
      name: "Fashion",
      type: "default",
    },
    {
      id: "023fbc5d-1050-466f-9e6c-397e7e255d5c",
      name: "Healthcare",
      type: "default",
    },
    {
      id: "00e9f2f6-b23a-402d-a407-b21e6b5e30a0",
      name: "Hospitality & Tourism",
      type: "default",
    },
    {
      id: "882b9544-9e09-41af-b1a9-1895424db320",
      name: "Human Resources",
      type: "default",
    },
    {
      id: "a06f1481-ead1-4027-88f2-50417f1f0a41",
      name: "Information Technology",
      type: "default",
    },
    {
      id: "a50b40bd-e5ea-4e57-8247-6c6b69f7aa0b",
      name: "Insurance",
      type: "default",
    },
    {
      id: "7655b1ba-6349-445f-a647-02994069d10c",
      name: "Legal Services",
      type: "default",
    },
    {
      id: "12a65323-758c-4ede-9319-a898940aef95",
      name: "Logistics & Supply Chain",
      type: "default",
    },
    {
      id: "ba914864-983b-4b62-b9c8-5586e7f8bbd8",
      name: "Manufacturing",
      type: "default",
    },
    {
      id: "902723cc-c83e-442d-a00c-e44fbb105b77",
      name: "Marketing & Advertising",
      type: "default",
    },
    {
      id: "a0c73b0f-1901-408b-b44a-f7a916487858",
      name: "Media & Broadcasting",
      type: "default",
    },
    {
      id: "cb72b42a-e82a-431a-94e8-bff6c82e307b",
      name: "Nonprofit",
      type: "default",
    },
    {
      id: "c5ddc685-1655-4291-8de2-238961c63973",
      name: "Pharmaceuticals",
      type: "default",
    },
    {
      id: "20ef7c48-56bd-47b2-a9ea-388d303912eb",
      name: "Real Estate",
      type: "default",
    },
    {
      id: "31616ce4-2a42-4039-9158-64090f3d50fe",
      name: "Retail",
      type: "default",
    },
    {
      id: "bb501aef-7e50-4726-b533-14e4357a7045",
      name: "Science & Research",
      type: "default",
    },
    {
      id: "9606a375-cf13-4e9d-88b5-22dc58230453",
      name: "Telecommunications",
      type: "default",
    },
    {
      id: "46074fa2-8686-4c49-a688-9194768a4113",
      name: "Transportation",
      type: "default",
    },
    {
      id: "e29b5576-3a66-407c-bf58-b51c58cda806",
      name: "Waste Management",
      type: "default",
    },
  ],
  company_profile: "Enterprise-Class",
  available_company_profiles: [
    {
      id: "f68147fc-e0ea-4a48-a729-6c2f53e9f80c",
      name: "Enterprise-Class",
      type: "default",
    },
    {
      id: "7b9f29ac-db1d-45cd-94aa-817276194f01",
      name: "Small Businesses",
      type: "default",
    },
    {
      id: "7bccfd8c-bb0c-4a3f-bf45-35e776a580a9",
      name: "Non-profit",
      type: "default",
    },
    {
      id: "964aa674-8e32-4caf-805e-ff143c21990f",
      name: "Mid-sized",
      type: "default",
    },
    {
      id: "bb8e9b89-e45e-4c2f-b4b4-a683f648a893",
      name: "Start ups",
      type: "default",
    },
  ],

  payRateValue: {
    max: "110",
    min: "90",
    minCurrency: "USD",
    maxCurrency: "USD",
  },
  pay_rate: {
    max: "110",
    min: "90",
    period: "",
    currency: "USD",
  },
  // functional_teams_data: [{ name: "Tech" }, { name: "Ops" }],
  // functional_teams: "Tech",
  functional_teams: handleDynmaicList([
    {
      name: "extracted",
      content: [],
    },
    {
      name: "inferred",
      content: ["Tech", "Dev Ops"],
    },
    {
      name: "user_added",
      content: [],
    },
  ]),
  functional_teams_value: "",
  management_level: "Senior",
  available_management_level: [
    {
      id: "c8925244-0093-441b-ac2d-e3cada2fa261",
      name: "Mid Level",
      type: "default",
    },
    {
      id: "15080972-6bb7-4b6c-a35f-5a194f6ead09",
      name: "Senior",
      type: "default",
    },
    {
      id: "03da1c83-d3a8-4e8c-8061-f9ee2fe376e4",
      name: "Fresher",
      type: "default",
    },
    {
      id: "aef19aaf-a17b-4cef-9812-352e6deed3b1",
      name: "Junior",
      type: "default",
    },
    {
      id: "f85c5ee8-84e6-4aac-9c25-3614025100ab",
      name: "Executive",
      type: "default",
    },
  ],
  employment: "Permanent - Full Time",
  available_employment_types: [
    {
      id: 1,
      name: "Contract - Part Time",
    },
    {
      id: 2,
      name: "Contract - Full Time",
    },
    {
      id: 3,
      name: "Permanent - Part Time",
    },
    {
      id: 1,
      name: "Permanent - Full Time",
    },
  ],
  Date_Range: {
    start_date: "",
    end_date: "",
  },
  package: "$ 10,000 - $15,000",
  // teamsize: "200-500",
  teamOrg: "Digital Team",
  occupational_classification: "Product",
  available_occupational_classification: [
    {
      id: "068b017c-6b81-4754-88bf-5a039a551e5a",
      name: "Design",
      type: "default",
    },
    {
      id: "32550d85-162d-4b90-bde4-26d5bfc4f6da",
      name: "Product",
      type: "default",
    },
    {
      id: "9dbbd46f-0cbf-42fb-b6a3-290d2d54a478",
      name: "General Management",
      type: "default",
    },
    {
      id: "ef873e75-b684-43ea-bf48-52d5c5b8c9e2",
      name: "Development",
      type: "default",
    },
    {
      id: "21b0b6fb-7815-4d8a-8fe1-f2f34902806b",
      name: "Finance",
      type: "default",
    },
    {
      id: "8409671d-3486-464d-87ef-bcfe77dcf7e2",
      name: "Marketing",
      type: "default",
    },
  ],
  project_type: "Onsite Only",
  available_project_type: [
    {
      id: "32550d85-162d-4b90-bde4-26d5bfc4f6da",
      name: "Onsite Only",
      type: "default",
    },
  ],
  teamsize: "5",
  available_team_size: [
    {
      id: "32550d85-162d-4b90-bde4-26d5bfc4f6da",
      name: "5",
      type: "default",
    },
  ],
  bids_from: "All/Pref. Ag/Agencies/Delivery Teams",
  available_bids_from: [
    {
      id: "32550d85-162d-4b90-bde4-26d5bfc4f6da",
      name: "All/Pref. Ag/Agencies/Delivery Teams",
      type: "default",
    },
  ],
  sow_owner_name: "Charles McKensie",
  available_sow_owner_name: [
    {
      id: "32550d85-162d-4b90-bde4-26d5bfc4f6da",
      name: "Charles McKensie",
      type: "default",
    },
  ],
  position: "Administrator",
  available_position: [
    {
      id: "32550d85-162d-4b90-bde4-26d5bfc4f6da",
      name: "Administrator",
      type: "default",
    },
  ],
  contact_info: "charles@mnstate.gov",
  reports_to: null,
  bu_department_team: null,
  location_targets: handleDynmaicList([
    {
      name: "extracted",
      content: [],
    },
    {
      name: "inferred",
      content: ["Dallas, TX", "St. Paul, MN"],
    },
    {
      name: "user_added",
      content: [],
    },
  ]),
  employer_targets: handleDynmaicList([
    {
      name: "extracted",
      content: [],
    },
    {
      name: "inferred",
      content: ["Chuck.E.Cheese", "TopGolf", "Gameworks"],
    },
  ]),
  languages: handleDynmaicList([
    {
      name: "extracted",
      content: [],
    },
    {
      name: "inferred",
      content: ["English"],
    },
    {
      name: "user_added",
      content: [],
    },
  ]),
  industryt_targets: handleDynmaicList([
    {
      name: "extracted",
      content: [],
    },
    {
      name: "inferred",
      content: ["Hospitality", "Entertainment"],
    },
    {
      name: "user_added",
      content: [],
    },
  ]),
  certificates: handleDynmaicList([
    {
      name: "extracted",
      content: [],
    },
    {
      name: "inferred",
      content: ["CDOs", "CTOs", "CIOs"],
    },
    {
      name: "user_added",
      content: [],
    },
  ]),
  dei: true,
  govt_security_clearance: false,
  insights: {
    insights: [
      {
        fix: false,
        content:
          "You have not provided the following mandatory fields: bu/department/team",
      },
    ],
    jd_recruiter_cheat_sheet: [
      "The key skills you are looking for are Python, Machine Learning, SQL, Statistical Analysis, and R. A Master's degree in Data Science or Statistics is required.",
      "Candidates should have strong communication skills and problem-solving abilities, with at least 6 years of relevant work experience, preferably in the education sector.",
      "Note that while R is preferred, candidates with hands-on experience in Python and Machine Learning will be prioritized, as these are critical for the role.",
      "As Big Data Technologies and Deep Learning Frameworks are also mentioned as nice-to-have skills, knowledge in these areas is optional but beneficial.",
      "Focus on analytical tools for data visualization such as Tableau and Power BI, as well as familiarity with statistical analysis to complement the primary techniques used in educational data science.",
    ],
    professional_writing_errors: [],
    punctuation_errors: [],
    spelling_errors: [],
  },
  score: 89.3,
  is_scored: false,
  education: "Bachelor's Degree",
  available_education: [
    {
      id: 1,
      name: "PHD Degree",
    },
    {
      id: 2,
      name: "Master's Degree",
    },
    {
      id: 3,
      name: "Bachelor's Degree",
    },
  ],
  shift: [],
  req_id: null,
  location: "St.Paul, MN",
  visa_status: "EAD",
  score_hard_skills: true,
  score_soft_skills: true,
  score_education: true,
  score_certificates: true,
  score_employer_targets: true,
  score_languages: true,
  score_visa: true,
  score_location_targets: true,
  score_functional_teams: true,
  interview_type: [],
  pre_screen_questions: [],
  relevancy_index:
    // [
    //   {
    //     id: "bb499e7e-2208-4ab9-a285-b2b0fa7771ba",
    //     type: "relevant_hard_skill",
    //     skill: "Machine Learning",
    //     order_no: 1,
    //     relevancy_score: 98,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "6ee11337-2124-44a7-844b-b30107dd810d",
    //     type: "relevant_hard_skill",
    //     skill: "Python",
    //     order_no: 2,
    //     relevancy_score: 95,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "47a5950c-6230-41a9-a6c2-d0131f0b5dd1",
    //     type: "relevant_hard_skill",
    //     skill: "SQL",
    //     order_no: 3,
    //     relevancy_score: 90,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "3fb3874e-56d5-4942-88df-d30ff66d4a90",
    //     type: "relevant_soft_skill",
    //     skill: "Communication",
    //     order_no: 4,
    //     relevancy_score: 90,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "a3d0b9ee-5882-427c-9f4a-01b589e3600b",
    //     type: "relevant_hard_skill",
    //     skill: "Statistical Analysis",
    //     order_no: 5,
    //     relevancy_score: 85,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "0e15503f-593b-451d-b0bb-48590da5f013",
    //     type: "relevant_soft_skill",
    //     skill: "Problem-Solving",
    //     order_no: 6,
    //     relevancy_score: 85,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "b125cdf4-7b06-4324-a77f-3652c1a98f18",
    //     type: "relevant_hard_skill",
    //     skill: "R",
    //     order_no: 7,
    //     relevancy_score: 80,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "3fced2d3-f3d7-4242-ae48-a27bfa086150",
    //     type: "relevant_soft_skill",
    //     skill: "Team Leadership",
    //     order_no: 8,
    //     relevancy_score: 80,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "3386fdb7-60ec-4ab9-a9ef-6f4a054ee479",
    //     type: "relevant_soft_skill",
    //     skill: "Critical Thinking",
    //     order_no: 9,
    //     relevancy_score: 78,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "7eafe404-aa75-4fd8-9ea4-726b839812d1",
    //     type: "relevant_hard_skill",
    //     skill: "Data Visualization (Tableau, Power BI)",
    //     order_no: 10,
    //     relevancy_score: 75,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "01bd59ae-db96-44e6-a172-327f7ee496ba",
    //     type: "relevant_soft_skill",
    //     skill: "Adaptability",
    //     order_no: 11,
    //     relevancy_score: 75,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "485dc648-67cd-4840-814f-9a328bcc4b90",
    //     type: "relevant_hard_skill",
    //     skill: "Deep Learning Frameworks (TensorFlow, PyTorch)",
    //     order_no: 12,
    //     relevancy_score: 65,
    //     skill_availability_status: "Specialized",
    //   },
    //   {
    //     id: "f46da86b-0840-4c8b-a894-7bb11c1d3a8f",
    //     type: "relevant_soft_skill",
    //     skill: "Collaboration",
    //     order_no: 13,
    //     relevancy_score: 65,
    //     skill_availability_status: "Easily Available",
    //   },
    //   {
    //     id: "09e68b03-b525-4c55-9a4a-d836d8657123",
    //     type: "relevant_hard_skill",
    //     skill: "Big Data Technologies (Hadoop, Spark)",
    //     order_no: 14,
    //     relevancy_score: 60,
    //     skill_availability_status: "Specialized",
    //   },

    [
      {
        id: "100",
        skill: "Strategic Technology Leadership",
        skill_availability_status: "Moderate",
        Type: "Tier 1",
        Onboarded: "Dec 6 2024",
        email: "olivia@mail.com",
        avatarUrl: "https://mui.com/static/images/avatar/1.jpg",
        relevancy_score: 95,
      },
      {
        id: "V-101",
        skill: "Digital Transformation Expertise",
        skill_availability_status: "Moderate",
        Type: "Tier 2",
        Onboarded: "Dec 6 2024",
        email: "lana@mail.com",
        avatarUrl: "https://mui.com/static/images/avatar/2.jpg",
        relevancy_score: 86,
      },
      {
        id: "102",
        skill: "AI and Data Analytics",
        skill_availability_status: "Moderate",
        Type: "Tier 3",
        Onboarded: "Dec 6 2024",
        email: "kate@mail.com",
        avatarUrl: "https://mui.com/static/images/avatar/3.jpg",
        relevancy_score: 85,
      },
      {
        id: "103",
        skill: "Team Leadership",
        skill_availability_status: "Moderate",
        Type: "Tier 2",
        Onboarded: "Dec 6 2024",
        email: "lana@mail.com",
        avatarUrl: "https://mui.com/static/images/avatar/7.jpg",
        relevancy_score: 85,
      },
      {
        id: "104",
        skill: "Change Leadership",
        skill_availability_status: "Moderate",
        Type: "Tier 2",
        Onboarded: "Dec 6 2024",
        email: "lana@mail.com",
        avatarUrl: "https://mui.com/static/images/avatar/4.jpg",
        relevancy_score: 85,
      },
    ],
  available_visa_status: [
    {
      id: 1,
      name: "EAD",
    },
    {
      id: 2,
      name: "H1B",
    },
  ],
};

const initialSections = [
  {
    name: "Key Deliverables",
    status: "Review Pending",
    icon: <SquareBoxTickIco />,
  },
  {
    name: "Team Composition",
    status: "Review Pending",
    icon: <TeamCompositionIco />,
  },
  {
    name: "Assemble Team",
    status: "Review Pending",
    icon: <AssembleTeamIco />,
  },
  {
    name: "Project Timeline",
    status: "Review Pending",
    icon: <ProjectTimelineIco />,
  },
  {
    name: "Questionnaire",
    status: "Review Pending",
    icon: <QuestionnaireIco />,
  },
  { name: "Documents", status: "Review Pending", icon: <DoucmentIco /> },
];

let dates = moment(new Date());
let today = dates.format("L");

const documentNoteUpperData = [
  {
    title: "Client",
    component: "input",
    fontSize: "15px",
    value: "State of Minnesota",
    placeholderFontSize: "15px",
    placeholder: "Enter the name",
  },
  {
    title: "Date",
    component: "input",
    fontSize: "15px",
    value: moment(today).format("DD MMM YYYY"),
    placeholderFontSize: "15px",
    placeholder: "Enter the number",
  },
  {
    title: "Position",
    fontSize: "15px",
    value: "Project Atlantis",
    placeholderFontSize: "15px",
    placeholder: "Enter H1B Holder Company Name",
  },
  // {
  //   title: "Job ID",
  //   fontSize: "15px",
  //   value: "2742866",
  //   placeholderFontSize: "15px",
  //   placeholder: "Enter H1B Holder Company Name",
  // },
];

const documentTypeData = [
  { name: "Standard", value: "Blank" },
  // { name: "Client Call", value: "Supplier Call" },
];

const ProposalGeneratorReview = ({
  alignItems,
  jobId,
  inputJdView,
  manualBoolean,
  keyData,
  handlePublishSow,
  edited,
  handleGenerateProposal,
  isLegal,
  isReview,
  isSubmitted,
  // allVerified,
}) => {
  console.log(manualBoolean, "manualBoolean");
  // const query = new URLSearchParams(useLocation().search);
  // const edited = query.get("isEdit");

  console.log(edited, "edited");
  const alignment = "Edit";
  const [isEdit, setIsEdit] = useState(edited === true ? true : false);
  const [skillDialog, setSkillDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [dialogData, setDialogData] = useState({
    skill: "",
    experience_in_yrs: "",
    criticality_score: "",
    title: "Create",
    classificationData: [],
    classification: false,
    classificationDataValue: "",
    key: "",
  });
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const JobJobEditData = useSelector((state) => state.jobs.jobJobEdit);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [editButtonLoading, setEditButtonLoading] = useState(false);
  const [open, setOpen] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const docuOpen = Boolean(anchorEl);
  const [noteList, setNoteList] = useState({
    open: false,
    laoding: false,
    noteId: "",
    type: "",
    note: "",
    created_at: "",
    job_history_reason: "",
    accecpting_less_more_candidates: "",
    locals_only: "",
    hybrid_days: "",
    project_scope: "",
    other_details: "",
    deadline_start: "",
    deadline_end: "",
  });
  const typeData = [
    { name: "Standard", value: "Blank" },
    // { name: "Client Call", value: "Supplier Call" },
  ];
  const [deleteNoteDialogOpen, setDeleteNoteDialogOpen] = useState(false);
  const [notesTableList, setNotesTableList] = useState([
    {
      note: "some...notes..",
      interaction: "Email",
      added_by: "Olivia Rhye",
      type: "Blank",
      created_at: "2025-02-12T05:38:03.293Z",
      title: "Notes",
    },
  ]);
  const [notesTableListLoading, setNotesTableListLoading] = useState(false);

  const tableContainerRef = React.useRef(null);
  let dates = moment(new Date());
  let today = dates.format("L");
  const [seededDialog, setSeededDialog] = useState({
    deleteOpen: false,
    loading: false,
    form: "",
    index: "",
    content: "",
    addOpen: false,
  });
  const navigate = useNavigate();
  const [fixLoader, setFixLoader] = useState(false);
  const value = (value) => (value ? value : "-");
  const [reScore, setReScore] = useState({
    disabled: false,
    noLoading: false,
    yesLoading: false,
    noteOpen: false,
  });

  const [activate, setActivate] = useState({
    inviteOpen: false,
    shareLoading: false,
    inviteLoading: false,
    activateOpen: isSubmitted ? true : false,
    backtoJobsLoading: false,
    disabled: false,
    roleLoading: false,
  });
  const [hyperDialogOpen, setHyperDialogOpen] = useState({
    inviteOpen: false,
    shareLoading: false,
    inviteLoading: false,
    activateOpen: false,
    backtoJobsLoading: false,
    disabled: false,
    roleLoading: false,
  });
  const [helixDialogOpen, setHelixDialogOpen] = useState({
    inviteOpen: false,
    shareLoading: false,
    inviteLoading: false,
    activateOpen: false,
    backtoJobsLoading: false,
    disabled: false,
    roleLoading: false,
  });
  const [jigsawDialogOpen, setJigsawDialogOpen] = useState({
    inviteOpen: false,
    shareLoading: false,
    inviteLoading: false,
    activateOpen: false,
    backtoJobsLoading: false,
    disabled: false,
    roleLoading: false,
  });
  const [openNoteDialog, setOpenNoteDialog] = useState(false);

  const [activeButtonDisable, setActivateButtonDisable] = useState(false);

  const [mileStonesTableData, setMileStonesTableData] = useState([
    {
      id: 100,
      team: "Salesforce Project Manager",
      cost: "$200",
      reqLevel: "Jesse Matthews - 92%",
      req: "1",
      recLevel: "Junior",
      rec: "0.75",
      location: "Onsite",
      allocation: "75%",
    },
    {
      id: 101,
      team: "Salesforce Business Analyst/Administrator",
      cost: "$2500",
      reqLevel: "NA",
      req: "1",
      recLevel: "Senior",
      rec: "0.2",
      location: "India",
      allocation: "20%",
    },
    {
      id: 102,
      team: "Salesforce Developer",
      cost: "$6000",
      reqLevel: "NA",
      req: "2",
      recLevel: "Mid-Level",
      rec: "1.5",
      location: "Hybrid",
      allocation: "100%",
    },
    {
      id: 103,
      team: "Salesforce Architect",
      cost: "$2000",
      reqLevel: "Sushir Singh - 96%",
      req: "1",
      recLevel: "Mid-Level",
      rec: "0.5",
      location: "India",
      allocation: "50%",
    },
    {
      id: 104,
      team: "Salesforce Quality Assurance Analyst",
      cost: "$150",
      reqLevel: "NA",
      req: "1",
      recLevel: "Mid-Level",
      rec: "1",
      location: "Romania",
      allocation: "60%",
    },
    {
      id: 105,
      team: "DevOps Personnel",
      cost: "$150",
      reqLevel: "NA",
      req: "1",
      recLevel: "Mid-Level",
      rec: "0.5",
      location: "India",
      allocation: "20%",
    },
  ]);
  const [formData, setFormData] = useState({
    designation: "",
    seniority: "",
    resourceCount: "",
    hrs: "",
    location: "",
    allocation: "",
    cost: "",
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [seeNoteOpen, setSeeNoteOpen] = useState(false);
  const [selectedNotes, setSelectedNotes] = useState([]);

  const handleSeeNote = (rowData) => {
    setSeeNoteOpen(true);
    setSelectedNotes(rowData.notes);
  };

  const handleCloseSeeNote = () => {
    setSeeNoteOpen(false);
    setSelectedNotes([]);
  };

  const totalCost = mileStonesTableData.reduce((sum, item) => {
    return sum + parseFloat(item.cost.replace("$", ""));
  }, 0);

  const handleAddTeam = () => {
    const newTeamMember = {
      id: (mileStonesTableData.length + 100).toString(),
      team: formData.designation,
      recLevel: formData.seniority,
      resources: formData.resourceCount,
      hrs: formData.hrs,
      reqLevel: "NA",
      location: formData?.location,
      allocation: `${formData?.allocation}%`,
      cost: `$${formData?.cost}`,
      req: "1",
    };

    setMileStonesTableData((prevData) => [...prevData, newTeamMember]);
    handleCloseDialog();
  };

  const handleChangeText = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleClickAddTeam = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setFormData({
      designation: "",
      senority: "",
      resourceCount: "",
      hrs: "",
      location: "",
    });
  };

  const [skillDropDownData, setSkillDropDownData] = useState(
    mileStonesTableData[0]?.team
  );

  const handleSkillDropDown = (e, selectedOption) => {
    setSkillDropDownData(e.target.value);
  };

  const handleRecLevelStatusChange = (event, rowId) => {
    const newStatus = event.target.value;
    setMileStonesTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, recLevel: newStatus } : row
      )
    );
  };

  const handleMileLoctionStatusChange = (event, rowId) => {
    const newStatus = event.target.value;
    setMileStonesTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, location: newStatus } : row
      )
    );
  };

  const jobModifyData = {
    job_title: "",
    company_name: "",
    industry: "",
    available_industry: Industry,
    payRateValue: {
      max: "",
      min: "",
      minCurrency: "USD",
      maxCurrency: "USD",
    },
    pay_rate: {
      max: "",
      min: "",
      currency: "USD",
    },
    management_level: "",
    available_management_level: [
      {
        id: "c8925244-0093-441b-ac2d-e3cada2fa261",
        name: "Mid Level",
        type: "default",
      },
      {
        id: "15080972-6bb7-4b6c-a35f-5a194f6ead09",
        name: "Senior",
        type: "default",
      },
      {
        id: "03da1c83-d3a8-4e8c-8061-f9ee2fe376e4",
        name: "Fresher",
        type: "default",
      },
      {
        id: "aef19aaf-a17b-4cef-9812-352e6deed3b1",
        name: "Junior",
        type: "default",
      },
      {
        id: "f85c5ee8-84e6-4aac-9c25-3614025100ab",
        name: "Executive",
        type: "default",
      },
    ],
    employment: "",
    available_employment_types: [
      {
        id: 1,
        name: "Contract - Part Time",
      },
      {
        id: 2,
        name: "Contract - Full Time",
      },
      {
        id: 3,
        name: "Permanent - Part Time",
      },
      {
        id: 1,
        name: "Permanent - Full Time",
      },
    ],
    Date_Range: {
      start_date: "",
      end_date: "",
    },
    coreData: [
      { name: "Familiar", value: "Familiar" },
      { name: "Hands-on", value: "Hands-on" },
      { name: "Expert", value: "Expert" },
    ],
    complementaryData: [
      { name: "Familiar", value: "Familiar" },
      { name: "Proven", value: "Proven" },
      { name: "USP", value: "USP" },
    ],
    recommendedData: [
      { name: "Familiar", value: "Familiar" },
      { name: "Hands-on", value: "Hands-on" },
      { name: "USP", value: "USP" },
    ],
    mediumData: [
      { name: "Preferred", value: "Preferred" },
      { name: "Desired", value: "Desired" },
      { name: "Required", value: "Required" },
    ],
    priorityData: [
      {
        name: "Medium",
        value: "Additional Qualities",
        key: "medium_priority",
      },
      {
        name: "High",
        value: "Complementary Skills",
        key: "low_priority",
      },
      {
        name: "Highest",
        value: "Core Skills",
        key: "high_priority",
      },
      {
        name: "Recommend",
        value: "Core recommended",
        key: "recommended",
      },
    ],
    skillType: [
      { name: "Core", value: "coreData" },
      { name: "Complementary", value: "complementaryData" },
      { name: "Recommend", value: "recommendedData" },
      { name: "Medium", value: "mediumData" },
    ],
    occupational_classification: "",
    available_occupational_classification: [],
    employeeTarget: "",

    autoCompleteValue: "",
    id: "",
    reports_to: "",
    req_id: "",
    bu_department_team: "",
    company_profile: "",
    available_company_profiles: [
      {
        id: "f68147fc-e0ea-4a48-a729-6c2f53e9f80c",
        name: "Enterprise-Class",
        type: "default",
      },
      {
        id: "7b9f29ac-db1d-45cd-94aa-817276194f01",
        name: "Small Businesses",
        type: "default",
      },
      {
        id: "7bccfd8c-bb0c-4a3f-bf45-35e776a580a9",
        name: "Non-profit",
        type: "default",
      },
      {
        id: "964aa674-8e32-4caf-805e-ff143c21990f",
        name: "Mid-sized",
        type: "default",
      },
      {
        id: "bb8e9b89-e45e-4c2f-b4b4-a683f648a893",
        name: "Start ups",
        type: "default",
      },
    ],
    education: "",
    available_education: [
      {
        id: 1,
        name: "PHD Degree",
      },
      {
        id: 2,
        name: "Master's Degree",
      },
      {
        id: 3,
        name: "Bachelor's Degree",
      },
    ],
    dei: false,
    govt_security_clearance: false,
    languages: [],
    certificates: [],
    certificates_value: "",
    employer_targets: [],
    employer_targets_value: "",
    location: "",
    languages_value: "",
    location_targets: [],
    location_targets_value: "",
    shift: [],
    shift_value: "",
    skillData: {
      low_priority: [],
      high_priority: [],
      recommended: [],
      medium_priority: [],
    },
    score_certificates: false,
    score_education: false,
    score_employer_targets: false,
    score_hard_skills: false,
    score_languages: false,
    score_location_targets: false,
    score_soft_skills: false,
    score_visa: false,
    relevancy_index: [],
    interview_type: [],
    pre_screen_questions: [],
    available_visa_status: [],
    visa_status: "",
    // functional_teams_data: [],
    functional_teams: [],
    functional_teams_value: "",
    score_functional_teams: "",
    skill: [
      {
        experience_in_yrs: "2",
      },
    ],
  };
  const noteUpperData = [
    {
      title: "Client",
      component: "input",
      fontSize: "15px",
      value: "State of Minnesota",
      placeholderFontSize: "15px",
      placeholder: "Enter the name",
    },
    {
      title: "Date",
      component: "input",
      fontSize: "15px",
      value: moment(today).format("DD MMM YYYY"),
      placeholderFontSize: "15px",
      placeholder: "Enter the number",
    },
    {
      title: "Position",
      fontSize: "15px",
      value: "Project Atlantis",
      placeholderFontSize: "15px",
      placeholder: "Enter H1B Holder Company Name",
    },
    // {
    //   title: "Job ID",
    //   fontSize: "15px",
    //   value: "2742866",
    //   placeholderFontSize: "15px",
    //   placeholder: "Enter H1B Holder Company Name",
    // },
  ];

  const [jobValue, setJobValue] = useState(jobModifyData);
  const [haloActivateDisable, setHaloActivateDisable] = useState(true);
  useEffect(() => {
    setIsLoading(true);
    if (manualBoolean) {
      setJobValue({
        ...jobValue,
        is_scored: false,
      });
    } else {
      setJobValue({
        ...jobValue,
        ...SowData,
      });
    }

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [JobJobEditData]);

  const validationSchema = Yup.object().shape({
    job_title: Yup.string().required("Title is required"),
    company_name: Yup.string().required("Company is required"),
    industry: Yup.string().required("Industry is required"),
    management_level: Yup.string().required("Seniority level is required"),
    employment: Yup.string().required("Employment type is required"),
    location: Yup.string().required("Location is required"),

    skillData: Yup.object({
      high_priority: Yup.array().of(
        Yup.object({
          skill: Yup.string().required("Skill is required"),
          experience_in_yrs: Yup.number()
            .required("Experience is required")
            .typeError("Please enter a valid number")
            .integer("Experience must be an integer"),
        })
      ),
      medium_priority: Yup.array().of(
        Yup.object({
          skill: Yup.string().required("Skill is required"),
          experience_in_yrs: Yup.number()
            .required("Experience is required")
            .typeError("Please enter a valid number")
            .integer("Experience must be an integer"),
        })
      ),
      low_priority: Yup.array().of(
        Yup.object({
          skill: Yup.string().required("Skill is required"),
          experience_in_yrs: Yup.number()
            .required("Experience is required")
            .typeError("Please enter a valid number")
            .integer("Experience must be an integer"),
        })
      ),
    }),
    pay_rate: Yup.object().shape({
      min: Yup.number()
        .typeError("Minimum pay rate must be a number")
        .min(0, "Minimum pay rate cannot be negative")
        .nullable(),
      max: Yup.number()
        .typeError("Maximum pay rate must be a number")
        .nullable()
        .when("min", (min, schema) =>
          min !== undefined && min !== null
            ? schema.moreThan(
                min,
                "Maximum pay rate must be greater than the minimum"
              )
            : schema
        ),
    }),

    checkcondition: Yup.boolean().test(
      "checkcondition",
      "At least one field (high, medium, or low priority) must have a value.",
      function (value, context) {
        const { high_priority, medium_priority, low_priority } =
          context.parent.skillData;
        return (
          (high_priority && high_priority.length > 0) ||
          (medium_priority && medium_priority.length > 0) ||
          (low_priority && low_priority.length > 0)
        );
      }
    ),
    Date_Range: Yup.object()
      .nullable()
      .shape({
        start_date: Yup.string(),
        end_date: Yup.string(),
      })
      .test(
        "start-end-date-not-same",
        "Start date and End date cannot be the same",
        function (value) {
          if (!value?.start_date || !value?.end_date) {
            return true;
          }
          return value.start_date !== value.end_date;
        }
      ),

    location_targets: Yup.array()
      .nullable()
      .of(
        Yup.object().shape({
          content: Yup.string(),
          id: Yup.mixed(),
        })
      )
      .test(
        "unique-content",
        "Location content must be unique",
        function (value) {
          if (!value) return true;
          const contentSet = new Set();
          for (let location of value) {
            if (location.content) {
              if (contentSet.has(location.content)) {
                return false;
              }
              contentSet.add(location.content);
            }
          }
          return true;
        }
      ),
    pre_screen_questions: Yup.array()
      .of(
        Yup.string()
          .test(
            "no-empty-string",
            "Empty strings are not allowed",
            (value) => value !== "" && value !== undefined
          )
          .required("This field is required")
      )
      .nullable()
      .optional(),
  });

  const validationSchemaScore = Yup.object().shape({
    skillData: Yup.object({
      high_priority: Yup.array().of(
        Yup.object({
          skill: Yup.string().required("Skill is required"),
          experience_in_yrs: Yup.number()
            .required("Experience is required")
            .typeError("Please enter a valid number")
            .integer("Experience must be an integer"),
        })
      ),
      medium_priority: Yup.array().of(
        Yup.object({
          skill: Yup.string().required("Skill is required"),
          experience_in_yrs: Yup.number()
            .required("Experience is required")
            .typeError("Please enter a valid number")
            .integer("Experience must be an integer"),
        })
      ),
      low_priority: Yup.array().of(
        Yup.object({
          skill: Yup.string().required("Skill is required"),
          experience_in_yrs: Yup.number()
            .required("Experience is required")
            .typeError("Please enter a valid number")
            .integer("Experience must be an integer"),
        })
      ),
    }),
    pay_rate: Yup.object().shape({
      min: Yup.number()
        .typeError("Minimum pay rate must be a number")
        .min(0, "Minimum pay rate cannot be negative")
        .nullable(),
      max: Yup.number()
        .typeError("Maximum pay rate must be a number")
        .nullable()
        .when("min", (min, schema) =>
          min !== undefined && min !== null
            ? schema.moreThan(
                min,
                "Maximum pay rate must be greater than the minimum"
              )
            : schema
        ),
    }),
    Date_Range: Yup.object()
      .nullable()
      .shape({
        start_date: Yup.string(),
        end_date: Yup.string(),
      })
      .test(
        "start-end-date-not-same",
        "Start date and End date cannot be the same",
        function (value) {
          if (!value?.start_date || !value?.end_date) {
            return true;
          }
          return value.start_date !== value.end_date;
        }
      ),

    location_targets: Yup.array()
      .nullable()
      .of(
        Yup.object().shape({
          content: Yup.string(),
          id: Yup.mixed(),
        })
      )
      .test(
        "unique-content",
        "Location content must be unique",
        function (value) {
          if (!value) return true;
          const contentSet = new Set();
          for (let location of value) {
            if (location.content) {
              if (contentSet.has(location.content)) {
                return false;
              }
              contentSet.add(location.content);
            }
          }
          return true;
        }
      ),
    pre_screen_questions: Yup.array()
      .of(
        Yup.string()
          .test(
            "no-empty-string",
            "Empty strings are not allowed",
            (value) => value !== "" && value !== undefined
          )
          .required("This field is required")
      )
      .nullable()
      .optional(),
  });

  const primaryViewData = [
    {
      title: "Project Name",
      component: "input",
      titleName: "job_title",
      name: "Project Atlantis",
    },
    {
      title: "Company",
      component: "input",
      titleName: "company_name",
      name: "State of Minnesota",
    },
    {
      title: "Industry",
      component: "dropDown",
      titleName: "industry",
      dropDownData: "available_industry",
      customColor: "rgb(0, 112, 242)",
      name: "Entertainment",
    },
    {
      title: "Location",
      component: "input",
      titleName: "location",
      name: "St.Paul, MN",
    },
    {
      title: "Bid Type",
      component: "dropDown",
      value: jobValue.employment,
      data: jobValue.available_employment_types,
      titleName: "employment",
      dropDownData: "available_employment_types",
      name: "Permanent - Full Time",
    },
    {
      title: "Duration",
      name: "",
      component: "calender",
      titleName: "Date_Range",
    },
    {
      title: "Project Type",
      component: "dropDown",
      titleName: "project_type",
      dropDownData: "available_project_type",
      customColor: "rgb(0, 112, 242)",
      name: "Onsite Only",
    },
    {
      title: "Budget",
      component: "input",
      titleName: "package",
      customColor: "rgb(0, 112, 242)",
      name: "$ 10,000 - $15,000",
    },
    // {
    //   title: "Functional Teams",
    //   component: "autoComplete",
    //   value: jobValue.employment,
    //   data: jobValue.available_employment_types,
    //   titleName: "functional_teams",
    //   dropDownData: "functional_teams_data",
    //   customColor: "rgb(0, 112, 242)",
    // },
    // {
    //   title: "Functional Teams",
    //   component: "autoComplete",
    //   // check: false,
    //   titleName: "functional_teams",
    //   placeholder: "Enter Function Teams",
    //   inputValue: "functional_teams_value",
    //   // check: jobValue.score_functional_teams,
    //   // toggleName: "score_functional_teams",
    //   // type: "additional",
    //   shift: ["Tech", "Ops"],
    // },
    {
      title: "Team Size",
      component: "dropDown",
      titleName: "teamsize",
      dropDownData: "available_team_size",
      customColor: "rgb(0, 112, 242)",
      name: "5",
    },
    {
      title: "Invite Bids from",
      component: "dropDown",
      titleName: "bids_from",
      dropDownData: "available_bids_from",
      name: "All/Pref. Ag/Agencies/Delivery Teams",
    },
    {
      title: "Company Profile",
      component: "dropDown",
      titleName: "company_profile",
      dropDownData: "available_company_profiles",
      customColor: "rgb(0, 112, 242)",
      name: "Enterprise-Class",
    },
    {
      title: "SoW Owner Name",
      component: "dropDown",
      titleName: "sow_owner_name",
      dropDownData: "available_sow_owner_name",
      name: "Charles McKensie",
    },
    {
      title: "Position",
      component: "dropDown",
      titleName: "position",
      dropDownData: "available_position",
      name: "Administrator",
    },
    {
      title: "Contact Info",
      component: "input",
      titleName: "contact_info",
      name: "Administrator",
    },
    // {
    //   title: "Highest Level of Education",
    //   name: "Bachelor’s Degree",
    //   component: "dropDown",
    //   titleName: "education",
    //   dropDownData: "available_education",
    //   check: jobValue.score_education,
    //   toggleName: "score_education",
    //   type: "additional",
    // },
    // {
    //   title: "Location Targets",
    //   component: "autoComplete",
    //   check: false,
    //   titleName: "location_targets",
    //   placeholder: "Enter Location Targets",
    //   inputValue: "location_targets_value",
    //   check: jobValue.score_location_targets,
    //   toggleName: "score_location_targets",
    //   type: "additional",
    //   additional: ["Dallas, TX", "St. Paul, MN"],
    // },
    // {
    //   title: "Goverment / Security Classification",
    //   check: jobValue.govt_security_clearance,
    //   toggleName: "govt_security_clearance",
    //   type: "additional",
    //   name: "No",
    // },
    // {
    //   title: "DEI",
    //   check: jobValue.dei,
    //   toggleName: "dei",
    //   type: "additional",
    //   name: "Yes",
    // },
  ];

  const SecondaryViewData = [
    {
      title: "Occupational Classification",
      component: "dropDown",
      titleName: "occupational_classification",
      dropDownData: "available_occupational_classification",
      customColor: "rgb(0, 112, 242)",
    },
    {
      title: "Package",
      component: "input",
      titleName: "package",
      customColor: "rgb(0, 112, 242)",
    },
    {
      title: "Functional Teams",
      component: "dropDown",
      value: jobValue.employment,
      data: jobValue.available_employment_types,
      titleName: "functional_teams",
      dropDownData: "functional_teams_data",
      customColor: "rgb(0, 112, 242)",
    },
    {
      title: "Team Size",
      component: "input",
      titleName: "teamsize",
      customColor: "rgb(0, 112, 242)",
    },
    {
      title: "Team/Org",
      component: "input",
      titleName: "req_id",
    },

    {
      title: "Company Profile",
      component: "dropDown",
      titleName: "company_profile",
      dropDownData: "available_company_profiles",
      customColor: "rgb(0, 112, 242)",
    },
  ];

  const additionalData = [
    {
      title: "Highest Level of Education",
      name: "Bachelor’s Degree",
      component: "dropDown",
      titleName: "education",
      dropDownData: "available_education",
      check: jobValue.score_education,
      toggleName: "score_education",
      type: "additional",
    },
    {
      title: "Location Targets",
      component: "autoComplete",
      // check: false,
      titleName: "location_targets",
      placeholder: "Enter Location Targets",
      inputValue: "location_targets_value",
      check: jobValue.score_location_targets,
      toggleName: "score_location_targets",
      type: "additional",
    },
    {
      title: "Target Candidate Roles",
      component: "autoComplete",
      titleName: "certificates",
      inputValue: "certificates_value",
      placeholder: "Enter Certifications",
      check: jobValue.score_certificates,
      toggleName: "score_certificates",
      type: "additional",
    },
    {
      title: "Employer Targets",
      component: "autoComplete",
      titleName: "employer_targets",
      inputValue: "employer_targets_value",
      placeholder: "Enter Employer Targets",
      check: jobValue.score_employer_targets,
      toggleName: "score_employer_targets",
      type: "additional",
    },
    {
      title: "Languages",
      component: "autoComplete",
      titleName: "languages",
      inputValue: "languages_value",
      placeholder: "Enter Languages",
      check: jobValue.score_languages,
      toggleName: "score_languages",
      type: "additional",
    },
    {
      title: "Industry Targets",
      component: "autoComplete",
      titleName: "industryt_targets",
      inputValue: "languages_value",
      placeholder: "Enter Industry Targets",
      check: jobValue.score_languages,
      toggleName: "score_languages",
      type: "additional",
    },

    {
      title: "Government / Security Classification",
      check: jobValue.govt_security_clearance,
      toggleName: "govt_security_clearance",
      type: "additional",
    },
    {
      title: "DEI",
      check: jobValue.dei,
      toggleName: "dei",
      type: "additional",
    },
  ];

  const headerData = [
    { name: "Skill" },
    { name: "Criticality" },
    { name: "Years" },
    ...(alignment === "Edit" ? [{ name: "" }] : []),
  ];

  const toggleRow = (index) => {
    setOpen((prev) => {
      const newState = { ...prev, [index]: !prev[index] };

      return newState;
    });
    setTimeout(() => {
      if (tableContainerRef.current) {
        const targetRow = tableContainerRef.current.querySelector(
          `.primary_${index}`
        );
        if (targetRow) {
          const targetCellTop = targetRow.getBoundingClientRect().top;
          const containerTop =
            tableContainerRef.current.getBoundingClientRect().top;
          const cellOffset = targetCellTop - containerTop;
          tableContainerRef.current.scrollTo({
            top: tableContainerRef.current.scrollTop + cellOffset - 60,
            behavior: "smooth",
          });
        }
      }
    }, 0);
  };

  const menuItemData = [
    {
      name: "USD",
    },
    { name: "INR" },
  ];

  const handleDeleteSkillRow = (data, form, type) => {
    setDialogData({
      key: type,
      data: data,
      form: form,
    });
    setDeleteDialog(true);
  };

  const handleClose = () => {
    setSkillDialog(false);
  };

  const handleAddNewSkill = (form) => {
    setSkillDialog(true);
    setDialogData({
      title: "Create",
      classification: true,
      experience_in_yrs: "",
      criticality_score: 0,
      skill: "",
      form: form,
    });
  };

  const handleSkillClick = async (values, form) => {
    setButtonLoading(true);
    setTimeout(() => {
      const skillDataKey = values.key;
      const currentSkillData =
        dialogData.form.values["skillData"][skillDataKey];
      const { classification, skill, ...rest } = values;

      let updatedSkillData;

      updatedSkillData = [...currentSkillData, values];

      const formData = {
        ...dialogData.form.values["skillData"],
        [skillDataKey]: updatedSkillData,
      };

      console.log(formData, "sfkjsnfsjkfnsjkfnjkn");
      dialogData.form.setFieldValue("skillData", formData);
      setSnackbarState({
        open: true,
        severity: "success",
        message: "updated Successfully",
      });
      setButtonLoading(false);
      setIsLoading(true);
      handleClose();
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }, 1000);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false);
  };

  const handleDeleteSkill = () => {
    setButtonLoading(true);
    let filterData;

    setTimeout(() => {
      filterData = dialogData.form.values["skillData"][dialogData.key].filter(
        (item) => item !== dialogData.data
      );

      const formData = {
        ...dialogData.form.values["skillData"],
        [dialogData.key]: filterData,
      };
      dialogData.form.setFieldValue("skillData", formData);

      setSnackbarState({
        open: true,
        severity: "success",
        message: `${
          dialogData?.data?.classification
            ? dialogData?.data?.classification
            : dialogData.data.skill
        } Removed Successfully`,
      });
      setButtonLoading(false);
      handleDeleteDialogClose();
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }, 1000);
  };

  const fetchJobEdit = async (jobId) => {
    setIsLoading(true);

    try {
      const data = await dispatch(JobJobEdit(jobId));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
    }
  };

  const handleSkillToogleChange = (
    event,
    newAlignment,
    rowIndex,
    form,
    type
  ) => {
    if (newAlignment !== null) {
      const dataKey = type;

      const updatedSkillData = form?.values?.["skillData"]?.[dataKey]?.map(
        (row) =>
          Array.isArray(row?.skill)
            ? { ...row, skill: row.skill.map((skill) => ({ ...skill })) }
            : { ...row }
      );

      const rowToUpdate = updatedSkillData?.[rowIndex];
      if (rowToUpdate) {
        rowToUpdate["expertise_level"] = newAlignment;
      }

      form.setFieldValue("skillData", {
        ...form?.values?.["skillData"],
        [dataKey]: updatedSkillData,
      });
    }
  };

  const handleSkillTextChange = (event, rowIndex, form, type, fieldName) => {
    const { value } = event.target;
    const dataKey = type;
    const updatedSkillData = form?.values?.["skillData"]?.[dataKey]?.map(
      (row) =>
        Array.isArray(row?.skill)
          ? { ...row, skill: row.skill.map((skill) => ({ ...skill })) }
          : { ...row }
    );

    const rowToUpdate = updatedSkillData?.[rowIndex];
    if (rowToUpdate) {
      rowToUpdate[fieldName] = value;
    }

    form.setFieldValue("skillData", {
      ...form?.values?.["skillData"],
      [dataKey]: updatedSkillData,
    });
  };

  const onSeededDragEnd = (result, form) => {
    const { destination, source } = result;
    if (!destination) return;
    if (destination.index === source.index) return;
    const update = [...form.values["pre_screen_questions"]];
    const [removed] = update.splice(source.index, 1);
    update.splice(destination.index, 0, removed);
    form.setFieldValue("pre_screen_questions", update);
  };

  const handleSeededDelete = (question, index, form) => {
    setSeededDialog({
      content: question,
      index: index,
      form: form,
      deleteOpen: true,
      loading: false,
      addOpen: false,
    });
  };

  const handleDeleteSeeded = () => {
    setSeededDialog((prev) => ({
      ...prev,
      loading: true,
    }));

    setTimeout(() => {
      const originalQuestions = [
        ...seededDialog?.form?.values["pre_screen_questions"],
      ];
      const updatedQuestions = originalQuestions.filter(
        (_, i) => i !== seededDialog?.index
      );

      seededDialog?.form?.setFieldValue(
        "pre_screen_questions",
        updatedQuestions
      );
      setSnackbarState({
        open: true,
        severity: "success",
        message: "Seeded Remvoved Successfully",
      });
      setIsLoading(true);
      handleSeededClose();

      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }, 1000);
  };

  const handleSeededClose = () => {
    setSeededDialog({
      content: "",
      index: "",
      form: "",
      deleteOpen: false,
      loading: false,
      addOpen: false,
    });
  };
  const ordinalNumbers = [
    "First",
    "Second",
    "Third",
    "Fourth",
    "Fifth",
    "sixth",
    "Seventh",
    "Eigth",
    "Ninth",
    "Tenth",
  ];
  const interviewTypes = jobValue.interview_type || [];
  const InterviewSettingData = interviewTypes.map((type, index) => ({
    title: `${ordinalNumbers[index] || `${index + 1}th`} Touch`,
    name: value(type),
    component: "input-list",
    titleName: "interview_type",
  }));

  const handleAddSeeded = (form) => {
    setSeededDialog((prev) => ({
      ...prev,
      addOpen: true,
      form: form,
    }));
  };

  const handleAddSubmit = (values) => {
    setSeededDialog((prev) => ({
      ...prev,
      loading: true,
    }));

    setTimeout(() => {
      const update = [...seededDialog.form.values["pre_screen_questions"]];
      const updatedQuestions = [...update, values.question];

      seededDialog.form.setFieldValue("pre_screen_questions", updatedQuestions);
      setSnackbarState({
        open: true,
        severity: "success",
        message: "Seeded Added Successfully",
      });
      setIsLoading(true);
      handleSeededClose();

      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }, 1000);
  };

  const handleClickAddNote = () => {
    setNoteList((prev) => ({
      ...prev,
      open: true,
      loading: false,
      noteId: "",
      type: "",
      note: "",
      created_at: "",
      job_history_reason: "",
      accecpting_less_more_candidates: "",
      locals_only: "",
      hybrid_days: "",
      project_scope: "",
      other_details: "",
      deadline_start: "",
      deadline_end: "",
    }));
  };

  const handleCloseNoteDialog = () => {
    setNoteList((prev) => ({
      ...prev,
      open: false,
      loading: false,
      noteId: "",
      type: "",
      note: "",
      created_at: "",
      job_history_reason: "",
      accecpting_less_more_candidates: "",
      locals_only: "",
      hybrid_days: "",
      project_scope: "",
      other_details: "",
      deadline_start: "",
      deadline_end: "",
    }));
  };

  const handleDeleteNoteClick = (row, index) => {
    console.log(row, "sfjsfjn");
    setDeleteNoteDialogOpen(true);
    setNoteList((prev) => ({
      ...prev,
      open: false,
      loading: false,
      noteId: index,
      type: row?.type,
      note: row?.note,
      created_at: row?.created_at,
      job_history_reason: "",
      accecpting_less_more_candidates: "",
      locals_only: "",
      hybrid_days: "",
      project_scope: "",
      other_details: "",
      deadline_start: "",
      deadline_end: "",
    }));
  };

  const handleDeleteNoteDialogClose = () => {
    setDeleteNoteDialogOpen(false);
    handleCloseNoteDialog();
  };

  const handleUpdateNoteClick = (row, index) => {
    setNoteList((prev) => ({
      ...prev,
      open: true,
      loading: false,
      noteId: index,
      type: row?.type,
      note: row?.note,
      created_at: row?.created_at,
      job_history_reason: row?.job_history_reason,
      accecpting_less_more_candidates: row?.accecpting_less_more_candidates,
      locals_only: row?.locals_only,
      hybrid_days: row?.hybrid_days,
      project_scope: row?.project_scope,
      other_details: row?.note,
      deadline_start: row?.deadline_start,
      deadline_end: row?.deadline_end,
    }));
  };

  const fetchNotesTableList = async (jobId) => {
    setNotesTableListLoading(true);
    const res = await GET(getJdNotes(jobId));
    if (res) {
      setNotesTableList(res?.data);
      setNotesTableListLoading(false);
    }
  };

  const handleCreateNote = async (values) => {
    setNotesTableListLoading(true);
    setNoteList((prev) => ({ ...prev, loading: true }));

    let payload;
    if (values.type === "Blank") {
      payload = {
        note: values.note,
        interaction: "Email",
        added_by: "username",
        type: values.type,
        created_at: new Date().toISOString(),
        title: "Notes",
      };
    } else {
      payload = {
        note: values.other_details,
        type: values.type,
        added_by: "username",
        hybrid_days: values.hybrid_days,
        deadline_start: values["Date_range"]?.["deadline_start"],
        deadline_end: values["Date_range"]?.["deadline_end"],
        job_history_type: values.job_history_type,
        job_history_reason: values.job_history_reason,
        accecpting_less_more_candidates: values.accecpting_less_more_candidates,
        locals_only: values.locals_only,
        project_scope: values.project_scope,
        created_at: new Date().toISOString(),
        title: "Notes",
      };
    }

    setTimeout(() => {
      setTimeout(() => {
        setNotesTableList((prevList) => {
          const indexToUpdate = prevList.findIndex(
            (item, index) => index === noteList.noteId
          );
          console.log(indexToUpdate, "indexToUpdate");

          if (indexToUpdate !== -1) {
            return prevList.map((item, index) =>
              index === indexToUpdate ? { ...item, ...payload } : item
            );
          } else {
            return [...prevList, payload];
          }
        });
      });

      setNotesTableListLoading(false);
      setSnackbarState({
        open: true,
        severity: "success",
        message: "Note added successfully",
      });

      handleCloseNoteDialog();
    }, 1000);
  };

  console.log(notesTableList, "notesTableList");

  const handleDeleteNoteById = async (id) => {
    setNotesTableListLoading(true);
    setNoteList((prev) => ({ ...prev, loading: true }));

    setTimeout(() => {
      setNotesTableList((prevList) =>
        prevList.filter((note, index) => index !== id)
      );
      setSnackbarState({
        open: true,
        severity: "success",
        message: "Note deleted successfully",
      });
      setNotesTableListLoading(false);
      handleDeleteNoteDialogClose();
    }, 1000);
  };

  const skillDropDown = [
    { name: "SalesForce Project Manager", id: 1 },
    { name: "Salesforce Business Analyst/Administrator", id: 2 },
    { name: "Salesforce Developer", id: 3 },
    { name: "SSalesforce Architect", id: 4 },
    { name: "Salesforce Quality Assurance Analyst", id: 5 },
  ];

  // const [skillDropDownData, setSkillDropDownData] = useState(
  //   skillDropDown[0]?.name
  // );
  const checklistRef = useRef(null);
  const [seeClicked, setSeeClicked] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [sections, setSections] = useState(initialSections);
  const allVerified = sections.every(
    (section) => section.status === "Verified"
  );

  console.log(allVerified, "allVerifiedbool");

  const handleCheckListCardClick = (index) => {
    setSelectedTab(index);
  };

  const handleClickVerify = () => {
    setSections((prevSections) =>
      prevSections.map((section, index) =>
        index === selectedTab ? { ...section, status: "Verified" } : section
      )
    );
  };

  useEffect(() => {
    if (seeClicked) {
      setSelectedTab(5);
    }
  }, [seeClicked]);

  //doucments

  const [documentSelectedRows, setDocumentSelectedRows] = useState([]);
  const [documentTableData, setDocumentTableData] = useState([
    {
      id: 1,
      fileName: "Project Atlantis.pdf",
      owner: "Olivia Rhye",
      status: "Approval Pending",
      notes: [
        {
          added_by: "Olivia Rhye",
          created_at: "2025-03-03T14:06:53.041Z",
          interaction: "Email",
          note: "The plan likely aims to define stakeholders (visitors, suppliers, governments, communities), assess benefits, summarize the rationale for the project, and outline objectives. ",
          title: "Notes",
          type: "Blank",
        },
        {
          added_by: "Olivia Rhye",
          created_at: "2025-03-03T14:06:53.041Z",
          interaction: "Email",
          note: "The document could be related to the ARPA-E project ATLANTIS",
          title: "Notes",
          type: "Blank",
        },
      ],
    },
    {
      id: 2,
      fileName: "Icanio References",
      owner: "Olivia Rhye",
      status: "Approval Pending",
      notes: [
        {
          added_by: "Olivia Rhye",
          created_at: "2025-03-03T14:06:53.041Z",
          interaction: "Email",
          note: "Icanio References Some Notes....",
          title: "Notes",
          type: "Blank",
        },
      ],
    },
    {
      id: 3,
      fileName: "Pitch Deck.ppt",
      owner: "Olivia Rhye",
      status: "Approval Pending",
      notes: [],
    },
  ]);

  const isAllApproved = documentTableData.every(
    (item) => item.status === "Enterprise Approved"
  );

  const fileInputRef = useRef(null);

  const handleDocumentFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      const newFileEntry = {
        id: documentTableData?.length + 1,
        fileName: file.name,
        owner: "Olivia Rhye", // Set the owner dynamically if needed
        status: "Approval Pending",
        notes: [],
      };

      setDocumentTableData((prevData) => [...prevData, newFileEntry]);
    }
  };

  const handleDocumentUploadClick = () => {
    fileInputRef.current.click(); // Trigger file input when button is clicked
  };

  const documentStatusOptions = [
    { label: "Approval Pending", color: "#DC6803" },
    { label: "Enterprise Approved", color: "#9E77ED" },
    { label: "Ready for Final Review", color: "#17B26A" },
    // { label: "NA", color: "#A0A0A0" },
  ];

  const handleDocumentStatusChange = (event, rowId) => {
    const newStatus = event.target.value;
    setDocumentTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, status: newStatus } : row
      )
    );
  };

  const menuData = [
    {
      title: "Add Note",
      image: <BoxEditIco />,
      onClick: () => handleAddNote(),
    },
    {
      title: "Delete",
      image: <DeleteIco />,
      onClick: () => handleDelete(documentSelectedRows),
    },
  ];

  const handleDocumentTableBodyData = (row) => {
    return (
      <>
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.fileName}
        </TableCell>
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.owner}
        </TableCell>
        <TableCell>
          <FormControl>
            <Select
              value={row.status || ""}
              displayEmpty
              onChange={(event) => handleDocumentStatusChange(event, row.id)} // Handle change
              renderValue={(selected) => {
                const selectedOption = documentStatusOptions.find(
                  (option) => option.label === selected
                );

                if (!selectedOption) {
                  return (
                    <Typography sx={{ color: "#A0A0A0" }}>
                      Select Level
                    </Typography>
                  );
                }

                return (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: selectedOption.color,
                        marginRight: "8px",
                      }}
                    />
                    <Typography>{selectedOption.label}</Typography>
                  </Box>
                );
              }}
              IconComponent={ExpandMore}
              sx={{
                "& .MuiSelect-select": {
                  paddingLeft: "10px !important",
                  paddingTop: "1px !important",
                  paddingBottom: "1px !important",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "6px",
                  paddingRight: "25px !important",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#D0D5DD",
                  boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                },
                "& .MuiSelect-icon": {
                  fontSize: "14px",
                },
              }}
            >
              {documentStatusOptions.map((option) => (
                <MenuItem key={option.label} value={option.label}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: option.color,
                        marginRight: "8px",
                      }}
                    />
                    {option.label}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
        {/* <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.note ? row.note : "-"}
        </TableCell> */}
        <TableCell
          sx={{ color: "#7F56D9", fontWeight: 700, fontSize: "16px" }}
          onClick={() => handleSeeNote(row)}
        >
          {row.notes?.length ? "See Comments" : "-"}
        </TableCell>
        <TableCell>
          <MoreVertOutlined
            style={{ cursor: "pointer" }}
            onClick={(e) => handleIconClick(e, row)}
          />
          <CustomMenuItem
            open={docuOpen}
            anchorEl={anchorEl}
            handleMenuClose={handleMenuClose}
            menuData={menuData}
            boxShadow="0px 0px 0px 0px rgba(16, 24, 40, 0.08),0px 3px 5px -3px rgba(16, 24, 40, 0.03)"
          />
        </TableCell>
      </>
    );
  };

  const handleDelete = (rowData) => {
    setDocumentTableData((prevData) =>
      prevData.filter((item) => item.id !== rowData.id)
    );
  };

  const handleAddNote = () => {
    setOpenNoteDialog(true);
  };

  const handleCloseDocumentNoteDialog = () => {
    setOpenNoteDialog(false);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleIconClick = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setDocumentSelectedRows(rowData);
  };

  const handleDocumentRowCheckboxChange = (rowId) => {
    setDocumentSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(rowId)
        ? prevSelectedRows.filter((id) => id !== rowId)
        : [...prevSelectedRows, rowId]
    );
  };

  const accordionDataView = [
    {
      title: "Summary",
      component: <IgniteSummary />,
    },
    {
      title: "Primary Information",
      component: !isEdit ? (
        <CommonCard viewData={primaryViewData} />
      ) : (
        <EditIndex
          editData={primaryViewData}
          menuItemData={menuItemData}
          loading={isLoading}
        />
      ),
    },
    {
      title: "Check List",
      component: (
        <div ref={checklistRef}>
          <Checklist
            isEdit={true}
            headerData={headerData}
            alignment={alignment}
            handleDeleteSkillRow={handleDeleteSkillRow}
            handleAddNewSkill={handleAddNewSkill}
            open={open}
            jobModifyData={jobModifyData}
            handleSkillToogleChange={handleSkillToogleChange}
            tableContainerRef={tableContainerRef}
            handleSkillTextChange={handleSkillTextChange}
            isLoading={isLoading}
            seeClicked={seeClicked}
            sections={sections}
            handleClickVerify={handleClickVerify}
            handleCheckListCardClick={handleCheckListCardClick}
            selectedTab={selectedTab}
            documentSelectedRows={documentSelectedRows}
            documentTableData={documentTableData}
            handleDocumentFileChange={handleDocumentFileChange}
            handleDocumentUploadClick={handleDocumentUploadClick}
            documentStatusOptions={documentStatusOptions}
            handleDocumentStatusChange={handleDocumentStatusChange}
            handleDocumentTableBodyData={handleDocumentTableBodyData}
            handleDocumentRowCheckboxChange={handleDocumentRowCheckboxChange}
            fileInputRef={fileInputRef}
            openDialog={openDialog}
            mileStonesTableData={mileStonesTableData}
            formData={formData}
            handleAddTeam={handleAddTeam}
            handleChangeText={handleChangeText}
            handleChange={handleChange}
            handleClickAddTeam={handleClickAddTeam}
            handleCloseDialog={handleCloseDialog}
            handleSkillDropDown={handleSkillDropDown}
            handleRecLevelStatusChange={handleRecLevelStatusChange}
            handleMileLoctionStatusChange={handleMileLoctionStatusChange}
            skillDropDownData={skillDropDownData}
            totalCost={totalCost}
          />
        </div>
      ),
    },

    {
      title: "Notes",
      component: (
        <Notes
          isShown={true}
          handleClickAddNote={handleClickAddNote}
          handleDeleteNoteClick={handleDeleteNoteClick}
          handleUpdateNoteClick={handleUpdateNoteClick}
          notesTableList={notesTableList}
          notesTableListLoading={notesTableListLoading}
        />
      ),
    },

    // {
    //   title: "Skills by Role",
    //   component: (
    //     <Skills
    //       headerData={headerData}
    //       alignment={isEdit ? alignment : ""}
    //       handleDeleteSkillRow={handleDeleteSkillRow}
    //       handleAddNewSkill={handleAddNewSkill}
    //       open={open}
    //       jobModifyData={jobModifyData}
    //       handleSkillToogleChange={handleSkillToogleChange}
    //       tableContainerRef={tableContainerRef}
    //       handleSkillTextChange={handleSkillTextChange}
    //       isLoading={isLoading}
    //     />
    //   ),
    // },
    // {
    //   title: "Settings",
    //   component: (
    //     <>
    //       <BidProcess isEdit={isEdit} />
    //     </>
    //   ),
    // },

    // {
    //   title: "Bid Generator",
    //   component: (
    //     <>
    //       <DesiredCompositionTableList isEdit={isEdit} />
    //     </>
    //   ),
    // },
    // ...(!jobValue.is_scored
    //   ? []
    //   : [
    //       {
    //         title: "Notes",
    //         component: (
    //           <Notes
    //             isShown={true}
    //             handleClickAddNote={handleClickAddNote}
    //             handleDeleteNoteClick={handleDeleteNoteClick}
    //             handleUpdateNoteClick={handleUpdateNoteClick}
    //             notesTableList={notesTableList}
    //             notesTableListLoading={notesTableListLoading || isLoading}
    //             isLoading={isLoading}
    //           />
    //         ),
    //       },
    //     ]),
  ];

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };
  const [reScoreButton, setReScoreButton] = useState(false);
  const handleSubmitJob = async (values, actions) => {
    setIsLoading(true);
    setEditButtonLoading(true);

    setTimeout(() => {
      if (!jobValue.is_scored) {
        setJobValue({
          ...jobValue,
          ...values,
          is_scored: true,
        });
        setSnackbarState({
          open: true,
          severity: "success",
          message: "Score SuccessFully",
        });
        setIsLoading(false);
        setEditButtonLoading(false);
        setHaloActivateDisable(false);
      } else {
        setActivateButtonDisable(true);
        setJobValue({
          ...jobValue,
          ...values,
          is_scored: true,
        });
        setSnackbarState({
          open: true,
          severity: "success",
          message: "Update SuccessFully",
        });
        setActivate((prev) => ({
          ...prev,
          activateOpen: true,
        }));
        setSnackbarState({
          open: true,
          severity: "success",
          message: "Update SuccessFully",
        });
        setIsLoading(false);
        setEditButtonLoading(false);
      }
    }, 1000);
  };

  const handleScrollToError = (errors) => {
    if (
      errors &&
      errors["skillData"] &&
      errors["skillData"]["extracted_hard_skills"] &&
      errors["skillData"]["extracted_hard_skills"]?.length !== 0
    ) {
      errors["skillData"]["extracted_hard_skills"].map((item, index) => {
        setOpen((prev) => {
          const newState = { ...prev, [index]: true };
          return newState;
        });
      });
    }
    setTimeout(() => {
      const errorElement = document.querySelector(".Mui-error");
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 0);
  };

  const resultHeaderData = ["Relevancy Index", "", "Relevancy Score", ""];

  const onRelevancyDragEnd = (result, form) => {
    const { source, destination } = result;
    if (!destination || destination.index === source.index) return;
    const reorderedCandidates = [...form.values["relevancy_index"]];
    const [removed] = reorderedCandidates.splice(source.index, 1);
    reorderedCandidates.splice(destination.index, 0, removed);
    form.setFieldValue("relevancy_index", reorderedCandidates);
  };

  const fetchJobsList = async (job_id) => {
    setFixLoader(true);
    setIsLoading(true);
    try {
      const response = await GET(fixedJob(job_id));
      setSnackbarState({
        open: true,
        message: response?.data?.message || "Fix applied successfully",
        severity: "success",
      });
      if (alignment === "Edit") {
        setJobValue(jobModifyData);
        fetchJobEdit(jobId);
      }

      setIsLoading(false);
      setFixLoader(false);
    } catch (err) {
      setSnackbarState({
        open: true,
        message: "An error occurred while applying the fix.",
        severity: "error",
      });
      setIsLoading(false);
      setFixLoader(false);
    }
  };

  const handleRescoreClose = () => {
    setIsLoading(false);
    setReScore({
      noLoading: false,
      disabled: false,
      yesLoading: false,
      noteOpen: false,
    });
  };

  const handleOpenUseHyper = () => {
    setHyperDialogOpen((prev) => ({
      ...prev,
      activateOpen: true,
    }));
  };

  const handleOpenHelix = () => {
    setHelixDialogOpen((prev) => ({
      ...prev,
      activateOpen: true,
    }));
  };

  const handleOpenJigsaw = () => {
    setJigsawDialogOpen((prev) => ({
      ...prev,
      activateOpen: true,
    }));
  };

  const handleHyperPopupClose = () => {
    setHyperDialogOpen({
      inviteOpen: false,
      shareLoading: false,
      inviteLoading: false,
      activateOpen: false,
      backtoJobsLoading: false,
      disabled: false,
    });
  };
  const handleHelixPopupClose = () => {
    setHelixDialogOpen({
      inviteOpen: false,
      shareLoading: false,
      inviteLoading: false,
      activateOpen: false,
      backtoJobsLoading: false,
      disabled: false,
    });
  };
  const handleJisawPopupClose = () => {
    setJigsawDialogOpen({
      inviteOpen: false,
      shareLoading: false,
      inviteLoading: false,
      activateOpen: false,
      backtoJobsLoading: false,
      disabled: false,
    });
  };

  const Footer = () => {
    return (
      <CommonGrid2 display={"flex"} gap={"1rem"}>
        <CommonButton
          value={"No"}
          variant="outlined"
          color="#344054"
          width={"100%"}
          padding={"10px"}
          marginTop={"2rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          border={"#D0D5DD"}
          onClick={() => handleClickScore("no", false)}
          disabled={reScore.disabled}
          loading={reScore.noLoading}
        />
        <CommonButton
          value={"Yes"}
          width={"100%"}
          padding={"10px"}
          marginTop={"2rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          disabled={reScore.disabled}
          loading={reScore.yesLoading}
          onClick={() => handleClickScore("yes", false)}
        />
      </CommonGrid2>
    );
  };

  const handleClickScore = async (condition, check) => {
    setReScore((prev) => ({
      ...prev,
      yesLoading: condition === "yes" ? true : false,
      noLoading: condition === "no" ? true : false,
      disabled: true,
    }));
    setIsLoading(true);

    let payload = {
      score: condition === "yes" ? true : false,
    };

    try {
      const response = await JobJobReScore(jobId, payload);
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;
        let boundaryIndex;
        while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
          const jsonString = buffer.slice(0, boundaryIndex + 1);
          buffer = buffer.slice(boundaryIndex + 1);
          const jsonResponse = JSON.parse(jsonString);
          try {
            await processJsonResponse(jsonResponse, check, condition);
          } catch (e) {
            setSnackbarState({
              open: true,
              message: "Error parsing JSON",
              severity: "error",
            });
            setIsLoading(false);
            setReScore({
              noLoading: false,
              disabled: false,
              yesLoading: false,
              noteOpen: true,
            });
          }
        }
      }

      if (buffer) {
        const jsonResponse = JSON.parse(buffer);
        try {
          await processJsonResponse(jsonResponse, check, condition);
        } catch (e) {
          setSnackbarState({
            open: true,
            message: "Error parsing final JSON chunk",
            severity: "error",
          });
          setIsLoading(false);
          setReScore({
            noLoading: false,
            disabled: false,
            yesLoading: false,
            noteOpen: true,
          });
        }
      }
    } catch (error) {
      setSnackbarState({
        open: true,
        message: "Error during the request",
        severity: "error",
      });
      setIsLoading(false);
      setReScore({
        noLoading: false,
        disabled: false,
        yesLoading: false,
        noteOpen: true,
      });
    }
  };

  const processJsonResponse = async (jsonResponse, check, condition) => {
    const { success, data, message } = jsonResponse;

    if (success && data?.percent !== undefined) {
    } else if (data?.response) {
      handleRescoreClose();
      setSnackbarState({
        open: true,
        severity: "success",
        message: message,
        // duration: 500,
      });
    } else if (!success) {
      setIsLoading(false);
      setReScore({
        noLoading: false,
        disabled: false,
        yesLoading: false,
        noteOpen: true,
      });
    }
  };

  const handleActivatePopup = (action) => {
    if (action === "share") {
      setActivate((prev) => ({
        ...prev,
        disabled: true,
        shareLoading: true,
      }));
      setTimeout(() => {
        setActivate((prev) => ({
          ...prev,
          activateOpen: false,
          disabled: false,
          inviteOpen: true,
          shareLoading: false,
        }));
      }, 1000);
    } else if (action === "back-to-jobs") {
      setActivate((prev) => ({
        ...prev,
        disabled: true,
        backtoJobsLoading: true,
      }));
      setTimeout(() => {
        setActivate((prev) => ({
          ...prev,
          disabled: false,
          backtoJobsLoading: false,
        }));
        navigate("/judica-scoring");
      }, 1000);
    } else if (action === "role") {
      setActivate((prev) => ({
        ...prev,
        disabled: true,
        roleLoading: true,
      }));
      setTimeout(() => {
        setActivate((prev) => ({
          ...prev,
          disabled: false,
          roleLoading: false,
        }));
        navigate("/leader-circle");
      }, 1000);
    }
  };

  const ActivateFooter = () => {
    return (
      // <CommonGrid2 display={"flex"} gap={"1rem"}>
      //   <CommonButton
      //     value={"Share"}
      //     width={"100%"}
      //     padding={"10px"}
      //     marginTop={"2rem"}
      //     fontWeight={"700"}
      //     fontSize={"15px"}
      //     disabled={activate.disabled}
      //     loading={activate.shareLoading}
      //     onClick={() => handleActivatePopup("share")}
      //   />
      //   <CommonButton
      //     value={"Back to Jobs"}
      //     variant="outlined"
      //     color="#344054"
      //     width={"100%"}
      //     marginTop={"2rem"}
      //     padding={"10px"}
      //     fontWeight={"700"}
      //     fontSize={"15px"}
      //     border={"#D0D5DD"}
      //     onClick={() => handleActivatePopup("back-to-jobs")}
      //     disabled={activate.disabled}
      //     loading={activate.backtoJobsLoading}
      //   />

      <Grid2 size={12}>
        <StyledFlexColumnView style={{ gap: "18px" }}>
          <CommonButton
            marginTop={"2rem"}
            variant="outlined"
            color="#344054"
            border="#D0D5DD"
            fontWeight="600"
            value="Add Exec profiles to role"
            padding="8px 15px"
            disabled={activate.disabled}
            loading={activate.roleLoading}
            onClick={() => handleActivatePopup("role")}
            // onClick={() => navigate(`/leader-circle`)}
          />
          <CommonButton
            variant="outlined"
            color="#344054"
            border="#D0D5DD"
            fontWeight="600"
            value="Share Exec Brief"
            padding="8px 15px"
            boxShadow={"0px 1px 2px 0px rgba(16, 24, 40, 0.05)"}
            disabled={activate.disabled}
            loading={activate.shareLoading}
            onClick={() => handleActivatePopup("share")}
          />
          <CommonButton
            variant="outlined"
            color="#344054"
            border="#D0D5DD"
            fontWeight="600"
            value="View Exec Brief"
            padding="8px 15px"
            boxShadow={"0px 1px 2px 0px rgba(16, 24, 40, 0.05)"}
            onClick={() => handleActivatePopup("back-to-jobs")}
            disabled={activate.disabled}
            loading={activate.backtoJobsLoading}
          />
        </StyledFlexColumnView>
      </Grid2>
    );
  };

  const handlePopupClose = () => {
    setActivate({
      inviteOpen: false,
      shareLoading: false,
      inviteLoading: false,
      activateOpen: false,
      backtoJobsLoading: false,
      disabled: false,
    });
  };

  const handleShareInvite = async (shareData) => {
    setActivate((prev) => ({
      ...prev,
      inviteLoading: true,
    }));

    setTimeout(() => {
      setSnackbarState({
        open: true,
        message: "Share Successfully",
        severity: "success",
      });
      handlePopupClose();
    }, 1000);
  };

  const handleScore = (values) => {
    setIsLoading(true);
    setReScoreButton(true);

    setTimeout(() => {
      setJobValue({
        ...jobValue,
        ...values,
        is_scored: true,
        ...(keyData === 1
          ? {
              insights: {
                insights: [
                  {
                    fix: false,
                    content:
                      "The job description aligns more closely with the title of 'Senior Cloud Network Engineer'. Would you like to update the current job title?",
                  },

                  {
                    fix: false,
                    content:
                      "You have specified work location as hybrid. Would you like to add more location hubs under location targets?",
                  },
                ],
                jd_recruiter_cheat_sheet: [
                  "The key skills you are looking for are Full Stack Development, ReactJS, Node.js, REST/Microservices, and Software Testing and Debugging. No specific educational qualifications are mentioned.",
                  "High-weightage attributes include Work Experience, Seniority, and Required Hard Skills, indicating strong emphasis on previous relevant experience and level of expertise.",
                  "Note that Node.js has been around for a while, but the incorporation of TypeScript (released in 2012) and AWS (Amazon Web Services) makes them newer elements; while their experience level may be lower due to their recent introduction.",
                  "As new technologies like TypeScript and AWS are part of the stack, older JavaScript or general cloud development skills become optional.",
                  "In terms of architectural methodology, focus on Microservices Architecture where primary tools include Node.js and frameworks like ReactJS, with Docker as a supporting tool for containerization.",
                ],
              },
              score: 90,
            }
          : keyData === 2
          ? {
              insights: {
                jd_recruiter_cheat_sheet: [
                  "The key skills you are looking for are C# Programming, SQL, GIS Arc, Python, and Software Development. A Bachelor's degree is required.",
                  "High-weightage attributes include work experience (0.16) and seniority (0.1), which are crucial in candidate selection.",
                  "Since the job requires GIS Arc, candidates may have less experience with it due to its continuous development, but it remains critical for this role.",
                  "As GIS Arc is a relatively recent technology, general GIS knowledge becomes optional.",
                  "This role may utilize tools and frameworks like ArcGIS for spatial analysis. Candidates should be familiar with associated software development methodologies.",
                ],
              },

              score: 94,
            }
          : keyData === 3 || keyData === 4
          ? {
              insights: {
                jd_recruiter_cheat_sheet: [
                  "The key skills you are looking for are Python, Machine Learning, SQL, Statistical Analysis, and R. A Master's degree in Data Science or Statistics is required.",
                  "Candidates should have strong communication skills and problem-solving abilities, with at least 6 years of relevant work experience, preferably in the education sector.",
                  "Note that while R is preferred, candidates with hands-on experience in Python and Machine Learning will be prioritized, as these are critical for the role.",
                  "As Big Data Technologies and Deep Learning Frameworks are also mentioned as nice-to-have skills, knowledge in these areas is optional but beneficial.",
                  "Focus on analytical tools for data visualization such as Tableau and Power BI, as well as familiarity with statistical analysis to complement the primary techniques used in educational data science.",
                ],
                professional_writing_errors: [],
                punctuation_errors: [],
                spelling_errors: [],
              },
              score: 92,
            }
          : keyData === 5
          ? {
              insights: {
                insights: [
                  {
                    fix: false,
                    content: "Congrats Good Look!",
                  },
                ],
              },
              score: 98,
            }
          : {}),
      });
      setSnackbarState({
        open: true,
        severity: "success",
        message: "Update SuccessFully",
      });

      setSnackbarState({
        open: true,
        severity: "success",
        message: "Update SuccessFully",
      });
      setIsLoading(false);
      setReScoreButton(false);
    }, 1000);
  };
  const [activateDialogOpen, setActivateDialogOpen] = useState(false);
  const [showSearchStrategy, setShowSearchStrategy] = useState(false);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const handleShareOpen = () => {
    setShareDialogOpen(true);
  };

  const handleActivateOpen = () => {
    setActivateButtonDisable(true);
    setHaloActivateDisable(true);
    setActivate((prev) => ({
      ...prev,
      activateOpen: true,
    }));
    setSnackbarState({
      open: true,
      severity: "success",
      message: "Update SuccessFully",
    });
  };
  const handleShareDialogClose = () => {
    setShareDialogOpen(false);
  };

  const handleSubmitBid = () => {
    setActivate((prev) => ({
      ...prev,
      activateOpen: true,
    }));
  };

  const handleEditViewProposal = () => {
    setIsEdit(!isEdit);
  };

  // useEffect(() => )
  // const steps = [
  //   // { id: "Step 1", label: "View Sow" },
  //   { id: "Step 2", label: "Generate Proposal" },
  //   { id: "Step 3", label: "Legal Approval" },
  //   { id: "Step 4", label: "Final Review" },
  //   { id: "Step 5", label: "Submit Proposal" },
  // ];
  // const [activeStep, setActiveStep] = useState(0);
  // const handleNext = (allVerified) => {
  //   console.log("Received Value in handleNext:", typeof allVerified);
  //   if (activeStep === 0 && !allVerified) {
  //     alert("You have not verified all the information in the Checklist.");
  //     return;
  //   }

  //   if (activeStep === steps.length - 1) {
  //     // handleGenerateBrief();
  //     return;
  //   }

  //   setActiveStep((prev) => prev + 1);
  // };

  const skillVal = {
    [mileStonesTableData[0]?.team]: "medium_priority",
    [mileStonesTableData[1]?.team]: "high_priority",
    [mileStonesTableData[2]?.team]: "low_priority",
    [mileStonesTableData[3]?.team]: "salesforce_architect",
    [mileStonesTableData[4]?.team]: "salesforce_quality_assurance_analyst",
    [mileStonesTableData[5]?.team]: "devOps_personnel",
  };

  const initialValuesSkill = {
    skill: "",
    experience_in_yrs: "",
    bucket: "Additional Qualities",
    // key: "high_priority",
    key: skillVal[skillDropDownData] || "recommended",
    expertise_level: "Familiar",
    type: "coreData",
    // ...(dialogData?.id && { id: dialogData?.id }),
  };

  const handleCreateDocumentNote = async (values) => {
    setNoteList((prev) => ({ ...prev, loading: true }));

    let payload;
    if (values.type === "Blank") {
      payload = {
        note: values.note,
        interaction: "Email",
        added_by: "Olivia Rhye",
        type: values.type,
        created_at: new Date().toISOString(),
        title: "Notes",
      };
    } else {
      payload = {
        note: values.other_details,
        type: values.type,
        added_by: "username",
        hybrid_days: values.hybrid_days,
        deadline_start: values["Date_range"]?.["deadline_start"],
        deadline_end: values["Date_range"]?.["deadline_end"],
        job_history_type: values.job_history_type,
        job_history_reason: values.job_history_reason,
        accecpting_less_more_candidates: values.accecpting_less_more_candidates,
        locals_only: values.locals_only,
        project_scope: values.project_scope,
        created_at: new Date().toISOString(),
        title: "Notes",
      };
    }

    setTimeout(() => {
      setTimeout(() => {
        // setSortedData((prevData) =>
        //   prevData.map((item) =>
        //     item.id === noteList.noteId
        //       ? { ...item, notes: [...item.notes, payload] } // Append note to the correct project's notes array
        //       : item
        //   )
        // );
        setDocumentTableData((prevData) =>
          prevData.map((item) =>
            item.id === documentSelectedRows.id
              ? { ...item, notes: [...item.notes, payload] }
              : item
          )
        );
        // setNotesTableList((prevList) => {
        //   const indexToUpdate = prevList.findIndex(
        //     (item, index) => index === noteList.noteId
        //   );
        //   console.log(indexToUpdate, "indexToUpdate");

        //   if (indexToUpdate !== -1) {
        //     return prevList.map((item, index) =>
        //       index === indexToUpdate ? { ...item, ...payload } : item
        //     );
        //   } else {
        //     return [...prevList, payload];
        //   }
        // });
      });

      setNotesTableListLoading(false);
      setSnackbarState({
        open: true,
        severity: "success",
        message: "Note added successfully",
      });

      handleCloseDocumentNoteDialog();
    }, 1000);
  };

  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={jobValue}
        validationSchema={
          !jobValue.is_scored ? validationSchemaScore : validationSchema
        }
        validateOnMount={true}
        onSubmit={async (values, actions) => {
          handleSubmitJob(values, actions);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          handleSubmit,
        }) => {
          return (
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
            >
              <Grid2 container fontFamily={"Inter"} spacing={3}>
                {/* <Grid2 size={12}>
                  <Breadcrumbs
                    breadCrumbData={[
                      { title: "Bidding Engine", navigate: -1 },
                      { title: "Sow Invites", navigate: -1 },
                      { title: "Project Atlantis Bids", active: true },
                    ]}
                  />
                </Grid2> */}

                {/* <Grid2 size={12}>
                  <Typography sx={{ fontSize: "24px", fontWeight: "600" }}>
                    {"Ignite Virtual Marketplace - Generate Proposal"}
                  </Typography>
                </Grid2> */}

                <CommonGrid2
                  size={{ xs: 12, md: 4, sm: 12 }}
                  item
                  alignItems={"center"}
                  display={"flex"}
                  fontFamily={"Inter"}
                >
                  <StyledFlexRowView>
                    <Typography variant="h3">
                      {jobValue?.job_title}
                      {/* {jobValue.company_name && " - " + jobValue?.company_name} */}
                      {jobValue.req_id && " - " + jobValue?.req_id}
                    </Typography>
                    <Button
                      variant="outlined"
                      startIcon={<SaveIco />}
                      sx={{
                        color: "#344054",
                        borderColor: "#D0D5DD",
                        fontWeight: "600",
                        borderRadius: "25px",
                        padding: "2px 10px",
                        gap: "0px",
                        "&:hover": {
                          backgroundColor: "transparent",
                          borderColor: "#D0D5DD",
                          color: "#344054",
                        },
                      }}
                      disabled={false}
                    >
                      {"Saved"}
                    </Button>
                  </StyledFlexRowView>
                </CommonGrid2>
                <CommonGrid2
                  item
                  size={{ xs: 12, md: 8, sm: 12 }}
                  gap="10px"
                  display="flex"
                  justifyContent={"end"}
                >
                  <StyledFlexRowView>
                    <CommonButton
                      variant="outlined"
                      color="#344054"
                      border="#D0D5DD"
                      fontWeight="700"
                      value="Share"
                      // padding="8px 15px"
                      padding={"10px 20px"}
                      onClick={handleShareOpen}
                      boxShadow={"0px 1px 2px 0px rgba(16, 24, 40, 0.05)"}
                    />
                    <CommonButton
                      variant="outlined"
                      color="#344054"
                      border="#D0D5DD"
                      fontWeight="700"
                      value="Add Note"
                      // padding="8px 15px"
                      padding={"10px 20px"}
                      // disabled={isLoading}
                      onClick={handleClickAddNote}
                      boxShadow={"0px 1px 2px 0px rgba(16, 24, 40, 0.05)"}
                    />

                    {isReview && (
                      <CommonButton
                        variant="contained"
                        color="white"
                        background="#7F56D9"
                        fontWeight="600"
                        value={isEdit ? "View Proposal" : "Edit Proposal"}
                        padding={"10px 20px"}
                        onClick={handleEditViewProposal}
                      />
                    )}

                    {/* {isReview && (
                      <CommonButton
                        variant="contained"
                        color="white"
                        background="#7F56D9"
                        fontWeight="600"
                        value={showSearchStrategy ? "ReScore" : "Score"}
                        padding="8px 15px"
                        // onClick={handleScoreClick}
                      />
                    )} */}
                  </StyledFlexRowView>
                  {jobValue.is_scored && isReview && (
                    <CommonButton
                      variant="contained"
                      color="white"
                      background="#7F56D9"
                      fontWeight="600"
                      padding={"10px 20px"}
                      value={"Re-score"}
                      disabled={
                        reScoreButton || isLoading || activeButtonDisable
                      }
                      loading={reScoreButton}
                      onClick={() => {
                        handleScore(values);
                      }}
                    />
                  )}

                  {!jobValue.is_scored && isReview && !isSubmitted && (
                    <CommonButton
                      variant="contained"
                      color="white"
                      background="#7F56D9"
                      fontWeight="600"
                      padding={"10px 20px"}
                      value={!jobValue.is_scored ? "Score" : "Activate"}
                      type="submit"
                      disabled={
                        editButtonLoading || isLoading || activeButtonDisable
                      }
                      loading={editButtonLoading}
                      onClick={() => {
                        setTimeout(() => {
                          handleScrollToError(errors);
                        }, 0);
                      }}
                    />
                  )}
                  {isReview && (
                    <CommonButton
                      variant="contained"
                      color="white"
                      background="#7F56D9"
                      fontWeight="600"
                      value={"Submit Proposal"}
                      // padding="8px 15px"
                      padding={"10px 20px"}
                      onClick={() => handleGenerateProposal()}
                      disabled={haloActivateDisable || isSubmitted}
                      // onClick={handlePublishSow}
                    />
                  )}
                  {!isReview && !isSubmitted && (
                    <CommonButton
                      variant="contained"
                      color="white"
                      background="#7F56D9"
                      fontWeight="600"
                      value={
                        isLegal
                          ? "Proceed to Approval"
                          : "Submit to Enterprise Approval"
                      }
                      // padding="8px 15px"
                      padding={"10px 20px"}
                      onClick={(event) => {
                        event.stopPropagation();
                        handleGenerateProposal(allVerified);
                      }}
                      // onClick={handleGenerateProposal}

                      // disabled={haloActivateDisable}
                      // onClick={handlePublishSow}
                    />
                  )}

                  {/* <CommonButton
                    variant="contained"
                    color="white"
                    background="#7F56D9"
                    fontWeight="600"
                    value="Submit Bid"
                    padding="8px 15px"
                    // disabled={haloActivateDisable}
                    onClick={handleSubmitBid}
                  /> */}

                  {/* {!edited && (
                    <CommonButton
                      variant="contained"
                      color="white"
                      background="#7F56D9"
                      fontWeight="600"
                      value="Generate Proposal"
                      padding="8px 15px"
                      onClick={handleGenerateProposal}
                    />
                  )} */}
                </CommonGrid2>

                {isLegal ? (
                  <Grid2 size={12}>
                    <Box
                      sx={{
                        flexGrow: 1,
                        border: "1px solid #EAECF0", // Add border here
                        borderRadius: "8px", // Add rounded corners
                        backgroundColor: "#FFFFFF", // White background
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.05)", // Optional subtle shadow
                        padding: "24px",
                      }}
                    >
                      <StyledSpaceBetweenBox>
                        <StyledFlexRowView>
                          {isAllApproved ? (
                            <PopupTickIco />
                          ) : (
                            <SquareBoxPendingIco />
                          )}

                          <StyledFlexColumnView>
                            <Typography
                              sx={{
                                fontSize: "18px",
                                fontWeight: 700,
                                color: "#101828",
                              }}
                            >
                              {isAllApproved
                                ? "Enterprise Team Approved"
                                : "Approved Pending !"}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "16px",
                                fontWeight: 400,
                                color: "#00144A",
                              }}
                            >
                              {isAllApproved
                                ? "The Enterprise Team have added some additional Files & Notes for you."
                                : "Please contact the Enterprise team for further details. "}
                            </Typography>
                          </StyledFlexColumnView>
                        </StyledFlexRowView>

                        <CommonButton
                          variant="contained"
                          color="white"
                          background="#7F56D9"
                          fontWeight="600"
                          value={"See"}
                          padding="10px 16px"
                          onClick={() => {
                            checklistRef.current?.scrollIntoView({
                              behavior: "smooth",
                            });
                            setSeeClicked(true);
                          }}
                        />
                      </StyledSpaceBetweenBox>
                    </Box>
                  </Grid2>
                ) : null}
              </Grid2>

              {jobValue.is_scored && <IgniteStrategy />}

              {/* {values["relevancy_index"]?.length !== 0 && (
                <Grid2 marginTop={"3rem"}>
                  <TeamAndKeyTableList />
                </Grid2>
              )} */}
              {accordionDataView.map((item, index) => (
                <CustomAccordion
                  defaultExpanded
                  //   expanded={expanded}
                  //   onChange={() => setExpanded(!expanded)}
                >
                  <AccordionSummary
                    expandIcon={<KeyboardArrowUpIcon />}
                    // expandIcon={
                    //   expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />
                    // }
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}
                    onClick={(e) => {
                      if (!e.target.closest(".expand-icon")) {
                        e.stopPropagation();
                      }
                    }}
                    style={{ pointerEvents: "none", fontFamily: "Inter" }}
                  >
                    <Typography
                      variant="h4"
                      margin={"15px 0px"}
                      fontWeight={600}
                      fontFamily={"Inter"}
                    >
                      {item.title}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {React.cloneElement(item.component, {
                      formikValues: values,
                      formikErrors: errors,
                      formikTouched: touched,
                      formikHandleChange: handleChange,
                      formikHandleBlur: handleBlur,
                      setFieldValue,
                    })}
                  </AccordionDetails>
                </CustomAccordion>
              ))}
              {/* <Grid2 marginTop={"3rem"}>
                  <BidProcess />
                </Grid2> */}

              {isEdit ? (
                <Grid2>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    //   mt={5}
                  >
                    <Stack direction="row" spacing={2}>
                      <CommonButton
                        variant="contained"
                        color="white"
                        background="#7F56D9"
                        value="Use Hyper to Assign team from ICE"
                        padding="8px 15px"
                        onClick={handleOpenUseHyper}
                      ></CommonButton>
                      <CommonButton
                        variant="contained"
                        color="primary"
                        value={"Activate Jobs to use Helix"}
                        padding="8px 15px"
                        onClick={handleOpenHelix}
                      ></CommonButton>
                      <CommonButton
                        variant="contained"
                        color="primary"
                        value={" Launch Jigsaw for Fit Analysis"}
                        padding="8px 15px"
                        onClick={handleOpenJigsaw}
                      ></CommonButton>
                    </Stack>
                    <Box mt={3}>
                      <CommonButton
                        variant="contained"
                        color="primary"
                        value={" Auto Generate Milestones"}
                        padding="8px 15px"
                      ></CommonButton>
                    </Box>
                    <Box mt={3}>
                      <CommonButton
                        variant="contained"
                        color="primary"
                        value={"Save"}
                        padding="8px 15px"
                      ></CommonButton>
                    </Box>
                  </Box>
                </Grid2>
              ) : null}

              {/* <Grid2 sx={{ marginTop: "25px" }}>
              
                <ProposalGanttChart isEdit={isEdit} />
              </Grid2> */}
              <AddIgniteSkill
                open={skillDialog}
                handleClose={handleClose}
                dialogData={dialogData}
                jobModifyData={jobModifyData}
                handleSkillClick={handleSkillClick}
                buttonLoading={buttonLoading}
                initialValuesSkill={initialValuesSkill}
              />
              <SkillDeleteDialog
                deleteDialog={deleteDialog}
                handleDeleteDialogClose={handleDeleteDialogClose}
                handleDeleteSkill={handleDeleteSkill}
                buttonLoading={buttonLoading}
                title="Delete Skill"
                content={dialogData?.data?.skill}
              />

              <SkillDeleteDialog
                deleteDialog={seededDialog.deleteOpen}
                handleDeleteDialogClose={handleSeededClose}
                handleDeleteSkill={handleDeleteSeeded}
                buttonLoading={seededDialog.loading}
                title="Delete Seeded Pre-Screen"
                content={seededDialog.content}
              />
              <AddSeededDialog
                open={seededDialog.addOpen}
                handleDialogClose={handleSeededClose}
                handleSubmit={handleAddSubmit}
                loading={seededDialog.loading}
              />
              <ShareQuickMatch
                shareDialogOpen={shareDialogOpen}
                handleShareDialogClose={handleShareDialogClose}
                title={"Share SoW"}
              />
            </Form>
          );
        }}
      </Formik>
      <NewDeleteNote
        deleteNoteDialogOpen={deleteNoteDialogOpen}
        handleDeleteNoteDialogClose={handleDeleteNoteDialogClose}
        noteList={noteList}
        handleDeleteNoteById={handleDeleteNoteById}
        noteLoading={noteList.loading}
      />
      <DialogCandidateHub
        open={reScore.noteOpen}
        disabled={reScore.disabled}
        closeIcon={true}
        handleButttonClose={handleRescoreClose}
        footer={<Footer />}
        icon={""}
        title="Re-Score"
        titlepadding={"0px 0px 16px"}
        content={"Do you want to rescore?"}
      />

      <CreateNote
        openNoteDialog={noteList.open}
        handleCloseNoteDialog={handleCloseNoteDialog}
        id={noteList.id}
        //
        noteUpperData={noteUpperData}
        typeData={typeData}
        noteList={noteList}
        handleNoteSubmit={handleCreateNote}
        loading={noteList.loading}
      />
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />

      <SubmitBidPopup
        activateDialogOpen={activate.activateOpen}
        handleActivateDialogClose={handlePopupClose}
      />

      <IgnitePopup
        activateDialogOpen={hyperDialogOpen.activateOpen}
        title={"Use Hyper Quick Match to assign team from Candidate Hub"}
        subTitle={
          "The team will be assigned from the pre existing Candidate Hub"
        }
        buttonName={"Run Hyper Quick Match"}
        handleActivateDialogClose={handleHyperPopupClose}
        icon={<SocksIco />}
      />
      <IgnitePopup
        activateDialogOpen={helixDialogOpen.activateOpen}
        title={"Launch Helix to create Jobs "}
        subTitle={
          "New jobs will be opened based on the skill requirement in the Proposal"
        }
        buttonName={"Launch Helix"}
        handleActivateDialogClose={handleHelixPopupClose}
        icon={<DnaIco />}
      />
      <IgnitePopup
        activateDialogOpen={jigsawDialogOpen.activateOpen}
        title={"Launch Jigsaw for Fit Analysis"}
        subTitle={
          "Jigsaw will analyze your current team and give you insights on how to bridge the gaps."
        }
        buttonName={"Launch Jigsaw"}
        handleActivateDialogClose={handleJisawPopupClose}
        icon={<PuzzleIco />}
      />
      {/* <DialogCandidateHub
        open={activate.activateOpen}
        handleButttonClose={handlePopupClose}
        icon={<PopupTickIco margin={"10px 0px 0px 10px"} />}
        footer={<ActivateFooter />}
        titlepadding={"0px 0px 10px"}
        title="Exec Brief - 10000 has been activated!"
        content={"What would you like to do next?"}
      /> */}

      <ShareQuickMatch
        title="Share Exec Brief"
        shareDialogOpen={activate.inviteOpen}
        handleShareDialogClose={handlePopupClose}
        handleShareInvite={handleShareInvite}
        isLoading={activate.inviteLoading}
      />

      <CreateNote
        openNoteDialog={openNoteDialog}
        handleCloseNoteDialog={handleCloseDocumentNoteDialog}
        // id={noteList.id}
        noteUpperData={documentNoteUpperData}
        typeData={documentTypeData}
        noteList={notesTableList}
        handleNoteSubmit={handleCreateDocumentNote}
      />

      {/* Notes Dialog */}
      <Dialog
        open={seeNoteOpen}
        onClose={handleCloseSeeNote}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ fontSize: "20px" }}>Notes</DialogTitle>
        <DialogContent>
          {selectedNotes.length > 0 ? (
            selectedNotes.map((note, index) => (
              <div key={index} style={{ marginBottom: "20px" }}>
                <StyledFlexColumnView>
                  <Typography variant="body1">
                    <strong>Added By:</strong> {note.added_by}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Date:</strong>{" "}
                    {moment(note.created_at).format("DD MMM YYYY")}
                  </Typography>
                  {/* <Typography variant="body2">
                  <strong style={{ color: "grey" }}>Type:</strong> {note.type}
                </Typography> */}
                  {/* <Typography variant="body2">
                  <strong>Interaction:</strong> {note.interaction}
                </Typography> */}
                  <Typography variant="body2">
                    <strong>Note:</strong>
                  </Typography>
                  <Typography sx={{ marginLeft: "20px" }}>
                    {note.note}
                  </Typography>
                </StyledFlexColumnView>
                <hr />
              </div>
            ))
          ) : (
            <Typography variant="body2">No notes available</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSeeNote} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default ProposalGeneratorReview;
